/* hgn-side-cart-attach.js — moved verbatim from snippets/hgn-side-cart-attach.liquid on 2026-09-19 (page-weight phase B:
   inline JS → theme asset, loaded synchronously at the same position so execution order and
   DOMContentLoaded timing are unchanged). 1 original <script> block(s), in order.
   EDIT THIS FILE, not the snippet. */

(function () {
  'use strict';
  var B = window.__hgnSideCartBridge;
  if (!B || !B.HGNSideCart) return;
  /* Load once — a second copy (double paste, or a probe injecting over
     a pasted theme) would wrap the prototype twice and fold savings
     twice. */
  if (B.HGNSideCart.prototype.__hgnAttachLoaded) return;
  B.HGNSideCart.prototype.__hgnAttachLoaded = true;
  var HGNSideCart = B.HGNSideCart;
  var H = B.helpers || {};
  var escapeHtml = H.escapeHtml || function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var formatMoney = H.formatMoney || function (cents) { return '£' + (cents / 100).toFixed(2); };
  var isGiftLineItem = H.isGiftLineItem || function (it) {
    return !!(it && it.properties && it.properties._gift_line === '1');
  };

  /* Fallbacks when the announcement bar has no product picked for a
     slot. Handles are live as of 2026-09-08 (products.json). A null
     slot simply never pitches. */
  var DEFAULT_HANDLES = {
    topcoat:  'magic-gloss-top-coat-holy-grail-nail',
    lamp:     'holy-grail-nail-led-lamp',
    pressons: 'adhesive-nail-tabs',
    bridge:   null
  };
  var SNOOZE_KEY = 'hgn_attach_snooze';
  var SNOOZE_MS  = 30 * 60 * 1000;
  var productCache = {};   /* handle → product json | null | Promise */

  /* ─── helpers ─── */
  function lc(s) { return String(s == null ? '' : s).toLowerCase(); }
  /* Catalogue titles carry the brand ("Magic Gloss Top Coat - Holy
     Grail Nail", "Holy Grail Nail - Extra Large Crystal Nail File");
     in a 56px row that just truncates the useful half. */
  function displayTitle(t) {
    return String(t || '')
      .replace(/\s*[-–—]\s*holy grail nail\s*$/i, '')
      .replace(/^\s*holy grail nail\s*[-–—]?\s*/i, '')
      .replace(/\s*\(uv\/led\)/i, '')
      .replace(/\s*[-–—]\s*holy (classics|gels)\b.*$/i, '')
      .replace(/\s*[-–—]\s*soft gel press ons\s*/i, ' ')
      .trim() || String(t || '');
  }
  function itemHandle(it) { return lc(it && it.handle); }
  function itemTitle(it)  { return lc(it && (it.product_title || it.title)); }
  function isTopCoat(it) {
    return itemHandle(it).indexOf('top-coat') !== -1 || itemTitle(it).indexOf('top coat') !== -1;
  }
  function isLamp(it) {
    /* Accessories only — "Lava Lamp" is a classic wrap design. */
    if (itemHandle(it).indexOf('led-lamp') !== -1) return true;
    return lc(it && it.product_type).indexOf('accessor') !== -1 && itemTitle(it).indexOf('lamp') !== -1;
  }
  /* Shared tier helper first, local substring classifier as fallback —
     live HGN.tierFromProductType returned null for product_type
     "press on" (2026-09-08 probe). */
  function classifyTier(pt) {
    var shared = null;
    try {
      if (window.HGN && typeof window.HGN.tierFromProductType === 'function') shared = window.HGN.tierFromProductType(pt);
    } catch (e) {}
    if (shared) return shared;
    var t = lc(pt).trim();
    if (t.indexOf('press') !== -1) return 'press-ons';
    if (t.indexOf('gel') !== -1 || t === 'crystal') return 'gels';
    if (t.indexOf('wrap') !== -1 || t.indexOf('non-uv') !== -1 || t.indexOf('mini me') !== -1) return 'classic';
    return null;
  }
  function isBundleLine(it) {
    var p = it && it.properties;
    if (!p) return false;
    return !!(p._bundle_id || p['_bundle_id'] || p['_box_id'] || p['Box ID']);
  }
  function attachSrc(it) {
    var p = it && it.properties;
    return p ? String(p._hgn_src || p['_hgn_src'] || '') : '';
  }
  function isPressOnEssential(it) {
    var h = itemHandle(it), t = itemTitle(it);
    return h.indexOf('adhesive') !== -1 || t.indexOf('adhesive') !== -1 ||
           h.indexOf('glue') !== -1     || t.indexOf('glue') !== -1 ||
           h.indexOf('press-on-nail-remover') !== -1 || t.indexOf('press on nail remover') !== -1;
  }
  function readSnooze() {
    try {
      var raw = localStorage.getItem(SNOOZE_KEY);
      var map = raw ? JSON.parse(raw) : {};
      var now = Date.now(), out = {};
      Object.keys(map).forEach(function (k) { if (now - map[k] < SNOOZE_MS) out[k] = map[k]; });
      return out;
    } catch (e) { return {}; }
  }
  function snooze(variantId) {
    try {
      var map = readSnooze();
      map[String(variantId)] = Date.now();
      localStorage.setItem(SNOOZE_KEY, JSON.stringify(map));
    } catch (e) {}
  }
  /* Normalise a config slot or a /products/<handle>.js payload into the
     one shape the renderer uses. Returns null if unusable. */
  function normalise(src, fromFetch) {
    if (!src) return null;
    if (fromFetch) {
      var v = (src.variants || []).filter(function (x) { return x.available; })[0];
      if (!v) return null;
      return {
        productId:  src.id,
        variantId:  v.id,
        handle:     src.handle,
        title:      src.title,
        image:      (src.featured_image || (src.images && src.images[0]) || ''),
        priceCents: v.price,
        available:  true
      };
    }
    if (!src.variantId || src.available === false) return null;
    return src;
  }
  /* Resolve a slot: config first, else fetch the default handle once.
     Returns a Promise<slot|null>. */
  function resolveSlot(cfgProducts, slot) {
    var fromCfg = normalise(cfgProducts && cfgProducts[slot], false);
    if (fromCfg) return Promise.resolve(fromCfg);
    if (cfgProducts && cfgProducts[slot] && cfgProducts[slot].available === false) return Promise.resolve(null);
    var handle = DEFAULT_HANDLES[slot];
    if (!handle) return Promise.resolve(null);
    if (productCache[handle] !== undefined && !(productCache[handle] && productCache[handle].then)) {
      return Promise.resolve(normalise(productCache[handle], true));
    }
    if (productCache[handle] && productCache[handle].then) return productCache[handle];
    var p = fetch('/products/' + handle + '.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (json) { productCache[handle] = json || null; return normalise(json, true); })
      .catch(function () { productCache[handle] = null; return null; });
    productCache[handle] = p;
    return p;
  }

  /* ─── the decision ─── */
  HGNSideCart.prototype._attachContext = function (groups) {
    var cart = this.cart;
    if (!cart || !cart.item_count) return null;
    var tierOf = classifyTier;
    var items = cart.items || [];
    var ctx = { wraps: false, gels: false, pressons: false, topcoat: false, lamp: false, pressonEssential: false, handles: {} };
    items.forEach(function (it) {
      if (isGiftLineItem(it)) return;
      var tier = tierOf(it.product_type);
      if (tier === 'classic') ctx.wraps = true;
      else if (tier === 'gels') ctx.gels = true;
      else if (tier === 'press-ons') ctx.pressons = true;
      if (isTopCoat(it)) ctx.topcoat = true;
      if (isLamp(it)) ctx.lamp = true;
      if (isPressOnEssential(it)) ctx.pressonEssential = true;
      if (it.handle) ctx.handles[lc(it.handle)] = true;
    });
    /* Same qualifying subtotal the meter uses (see _renderProgress). */
    var giftLine = items.filter(isGiftLineItem)[0];
    var giftRetail = giftLine
      ? (giftLine.original_line_price != null ? giftLine.original_line_price : (giftLine.line_price || 0))
      : 0;
    ctx.subtotalCents = Math.max(0,
      (cart.items_subtotal_price || 0)
        - (this._lastBundleSavingsCents || 0)
        - (this._lastAdHocSavingsCents || 0)
        - (pairPresCents(cart) || 0)
        - giftRetail) + (this._virtualKitMeterCents || 0);
    var cur = lc(cart.currency || 'GBP');
    var shipCfg = (this.config && this.config.shipping) || {};
    var shipGbp = shipCfg[cur] != null ? shipCfg[cur] : (shipCfg.gbp || 40);
    ctx.shipCents = Math.round(this._convertThreshold(shipGbp) * 100);
    var npActive = false;
    try { npActive = this._getDiscountIntent() === 'nailpoints'; } catch (e) {}
    var giftTier = (!npActive && this.config && this.config.gift && this.config.gift.tiers && this.config.gift.tiers[0]) || null;
    ctx.giftName = giftTier ? (giftTier.friendlyName || giftTier.title || 'gift') : null;
    ctx.giftCents = giftTier ? Math.round(this._convertThreshold((this.config.gift.thresholdGbp || 50)) * 100) : null;
    /* Distinct standalone design lines in the busiest tier — drives
       the row's position relative to the kit card (see _placeAttach). */
    var tierLines = {};
    items.forEach(function (it) {
      if (isGiftLineItem(it) || isBundleLine(it)) return;
      var t = tierOf(it.product_type);
      if (!t || t === 'accessories') return;
      tierLines[t] = (tierLines[t] || 0) + 1;
    });
    ctx.maxDesignLines = Object.keys(tierLines).reduce(function (m, k) { return Math.max(m, tierLines[k]); }, 0);
    ctx.shipUnlocked = ctx.subtotalCents >= ctx.shipCents;
    ctx.giftUnlocked = !!(giftTier && ctx.subtotalCents >= ctx.giftCents);
    return ctx;
  };

  /* Ordering rule (Matt, 2026-09-08): at ONE design line the one-tap
     top coat is the easy ask and goes ABOVE the kit card; from two
     design lines the shopper is stacking designs and the kit card
     leads. Cheap DOM move, idempotent. */
  HGNSideCart.prototype._placeAttach = function (first) {
    var host = this._attachEl, up = this.upsellEl;
    if (!host || !up || !up.parentNode) return;
    if (first) {
      if (host.nextSibling !== up) up.parentNode.insertBefore(host, up);
    } else {
      if (host.previousSibling !== up) up.parentNode.insertBefore(host, up.nextSibling);
    }
  };

  /* Relevance-ordered slot list for this basket. */
  function relevantSlots(ctx) {
    var slots = [];
    if ((ctx.wraps || ctx.gels) && !ctx.topcoat) slots.push('topcoat');
    if (ctx.gels && !ctx.lamp) slots.push('lamp');
    if (ctx.pressons && !ctx.pressonEssential) slots.push('pressons');
    return slots;
  }

  HGNSideCart.prototype._renderAttach = function (groups) {
    var self = this;
    var cfg = (this.config && this.config.attach) || {};
    var host = this._attachEl;
    if (!host) {
      if (!this.upsellEl || !this.upsellEl.parentNode) return;
      host = document.createElement('div');
      host.className = 'hgn-side-cart__attach';
      host.setAttribute('data-hgn-side-cart-attach', '');
      host.hidden = true;
      this.upsellEl.parentNode.insertBefore(host, this.upsellEl.nextSibling);
      this._attachEl = host;
    }
    var hide = function () { host.hidden = true; host.innerHTML = ''; host.className = 'hgn-side-cart__attach'; };
    if (cfg.enabled === false) { hide(); return; }
    var ctx = this._attachContext(groups);
    if (!ctx) { hide(); return; }
    this._placeAttach(ctx.maxDesignLines <= 1);

    /* Stand-down: kit mid-build with picks, or Nail Drop queue active —
       same voice-arbitration as the kit card. */
    try {
      var kp = window.HGN && window.HGN.kitProgress;
      if (kp && typeof kp.getKitBuildMode === 'function' && kp.getKitBuildMode() === 'on' &&
          typeof kp.totalKitPicks === 'function' && kp.totalKitPicks() > 0) { hide(); return; }
      var dq = window.HGN && window.HGN.dropQueue;
      if (dq && typeof dq.queueLength === 'function' && dq.queueLength() > 0 &&
          window.HGN.shopMode && typeof window.HGN.shopMode.isDropAvailable === 'function' &&
          window.HGN.shopMode.isDropAvailable()) { hide(); return; }
    } catch (e) {}

    var slots = relevantSlots(ctx);
    var windowCents = Math.round(this._convertThreshold(cfg.bridgeWindowGbp || 12) * 100);
    var shipGap = ctx.shipUnlocked ? 0 : (ctx.shipCents - ctx.subtotalCents);
    var giftGap = (ctx.giftCents && ctx.shipUnlocked && !ctx.giftUnlocked) ? (ctx.giftCents - ctx.subtotalCents) : 0;
    var bridging = (shipGap > 0 && shipGap <= windowCents) ? 'ship'
                 : (giftGap > 0 && giftGap <= windowCents) ? 'gift' : null;
    /* A bridge can also lean on the generic bridge item. */
    if (bridging && slots.indexOf('bridge') === -1) slots.push('bridge');
    if (!slots.length) { hide(); return; }

    var products = cfg.products || {};
    var token = (this._attachToken = (this._attachToken || 0) + 1);
    Promise.all(slots.map(function (s) { return resolveSlot(products, s); })).then(function (resolved) {
      if (token !== self._attachToken) return;   /* stale render */
      var snoozed = readSnooze();
      var cands = [];
      resolved.forEach(function (p, i) {
        if (!p || !p.variantId) return;
        if (snoozed[String(p.variantId)]) return;
        if (p.handle && ctx.handles[lc(p.handle)]) return;   /* already in basket */
        cands.push({ slot: slots[i], p: p });
      });
      if (!cands.length) { hide(); return; }

      var pick = null, reason = 'attach';
      if (bridging) {
        var gap = bridging === 'ship' ? shipGap : giftGap;
        var clears = cands.filter(function (c) { return c.p.priceCents >= gap; });
        if (clears.length) {
          /* Relevance order wins among clearers; the bridge slot is last. */
          pick = clears[0];
          reason = bridging === 'ship' ? 'bridge_ship' : 'bridge_gift';
        }
      }
      if (!pick) {
        pick = cands.filter(function (c) { return c.slot !== 'bridge'; })[0] || null;
      }
      if (!pick) { hide(); return; }

      var p = pick.p;
      var eyebrow, sub;
      if (reason === 'bridge_ship') {
        eyebrow = formatMoney(shipGap, self.cart.currency) + ' to free shipping';
        sub = 'Add this and shipping is <strong>free</strong>';
      } else if (reason === 'bridge_gift') {
        eyebrow = formatMoney(giftGap, self.cart.currency) + ' to your free ' + escapeHtml(ctx.giftName);
        sub = 'Add this and the <strong>' + escapeHtml(ctx.giftName) + '</strong> is on us';
      } else {
        eyebrow = pick.slot === 'pressons' ? 'For your press-ons'
                : pick.slot === 'lamp'     ? 'For your gels'
                : (ctx.gels && !ctx.wraps) ? 'Goes with your gels' : 'Goes with your wraps';
        sub = 'One tap, ships in the same parcel';
      }
      host.className = 'hgn-side-cart__attach';
      host.setAttribute('data-hgn-attach-reason', reason);
      host.setAttribute('data-hgn-attach-slot', pick.slot);
      host.innerHTML =
        '<button type="button" class="hgn-side-cart__attach-dismiss" data-hgn-attach-dismiss aria-label="Not now">' +
          '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
        '</button>' +
        '<a class="hgn-side-cart__attach-thumb" href="/products/' + encodeURIComponent(p.handle || '') + '" tabindex="-1" aria-hidden="true">' +
          (p.image ? '<img src="' + escapeHtml(p.image) + '" alt="" loading="lazy" width="56" height="56">' : '') +
        '</a>' +
        '<div class="hgn-side-cart__attach-body">' +
          '<p class="hgn-side-cart__attach-eyebrow">' + eyebrow + '</p>' +
          '<p class="hgn-side-cart__attach-title">' + escapeHtml(displayTitle(p.title)) + '</p>' +
          '<p class="hgn-side-cart__attach-sub">' + sub + '</p>' +
        '</div>' +
        '<button type="button" class="hgn-side-cart__attach-cta" data-hgn-attach-add>' +
          'Add · ' + formatMoney(p.priceCents, self.cart.currency) +
        '</button>';
      host.hidden = false;

      var addBtn = host.querySelector('[data-hgn-attach-add]');
      var dismissBtn = host.querySelector('[data-hgn-attach-dismiss]');
      if (dismissBtn) {
        dismissBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          snooze(p.variantId);
          hide();
        });
      }
      if (addBtn) {
        addBtn.addEventListener('click', function () {
          if (self._attachInflight) return;
          self._attachInflight = true;
          addBtn.disabled = true;
          addBtn.textContent = 'Adding…';
          fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              items: [{
                id: parseInt(p.variantId, 10),
                quantity: 1,
                properties: { '_hgn_src': 'sidecart_attach:' + reason + ':' + pick.slot }
              }]
            })
          }).then(function (r) {
            if (!r.ok) throw new Error('add failed ' + r.status);
            host.classList.add('is-added');
            addBtn.textContent = 'Added ✓';
            try {
              document.dispatchEvent(new CustomEvent('hgn:attach:add', {
                detail: { reason: reason, slot: pick.slot, variantId: p.variantId, handle: p.handle }
              }));
            } catch (e) {}
            return self.refresh();
          }).catch(function () {
            addBtn.disabled = false;
            addBtn.textContent = 'Try again';
          }).then(function () {
            self._attachInflight = false;
          });
        });
      }
    });
  };

  /* ─── kit upsell click: carry a standalone accessory into the kit ───
     A shopper who took the top coat one-tap and then builds a kit
     would otherwise pick a second top coat inside the kit and keep
     the standalone too. After the original handler has cleared and
     prefilled the tier, match standalone accessory lines against the
     tier's HGN_KIT_ACCESSORIES options, set the slot pick, and add
     the line key to the pending snapshot so _reconcilePendingUpsell
     removes it when the bundle lands. */
  var origUpsellClick = HGNSideCart.prototype._handleUpsellClick;
  HGNSideCart.prototype._handleUpsellClick = function (match) {
    var out = origUpsellClick.apply(this, arguments);
    try {
      var kp = window.HGN && window.HGN.kitProgress;
      var pending = this._pendingUpsell;
      var tierAcc = (window.HGN_KIT_ACCESSORIES || {})[match && match.tier] || {};
      if (!kp || typeof kp.setAccessory !== 'function' || !pending || !this.cart) return out;
      var carried = [];
      (this.cart.items || []).forEach(function (it) {
        if (isBundleLine(it) || isGiftLineItem(it)) return;
        Object.keys(tierAcc).forEach(function (slot) {
          if (slot === 'giftBag') return;
          var opt = (tierAcc[slot] || []).filter(function (o) {
            return o && String(o.variantId) === String(it.variant_id);
          })[0];
          if (!opt) return;
          if (kp.setAccessory(match.tier, slot, opt)) {
            if (pending.cartLineKeys.indexOf(it.key) === -1) pending.cartLineKeys.push(it.key);
            carried.push(slot);
          }
        });
      });
      if (carried.length && window.console && console.info) console.info('[hgn-side-cart-attach] carried into kit:', carried.join(','));
    } catch (e) {}
    return out;
  };


  /* ═══════════ Checkout-tap pair offer (round two, 2026-09-08) ═══════════
     A card ABOVE the Checkout button (which never changes — Matt's
     2026-09-09 review: swapping the CTA was checkout friction): "Why not
     add <the design you recently viewed> for £2.00 off?" with its own
     Add button and a No thanks. Shown while the drawer is open once a
     candidate resolves; the shopper checks out when they are ready.
     Candidate = newest recently-viewed record (hgn-header-viewed
     localStorage) in the basket's busiest tier, in stock, not already
     in the basket. No candidate → no offer (mystery fallback dropped,
     Matt 2026-09-08). Shown once per basket signature per session.

     The saving is folded the way KIT5 is: the line carries
     `_hgn_pair_gbp_cents` / `_hgn_pair_pres_cents`, and the _render
     wrapper adds them to _lastSavingsGbpCents / _lastSavingsCents /
     the displayed rows, so _proceedToCheckout mints it inside the same
     BASKET-* code. The worker trusts the client figure (create route),
     and BASKET-* is minted combinable — no worker change.

     Guards: default intent only (Nail Points and ad-hoc codes take
     their own checkout paths), no kit awaiting finalise, no mint
     failure armed, one pair line per order, and never when the
     discount would drop a basket back under a threshold the drawer
     has just celebrated (Shopify rates shipping on the discounted
     subtotal). A pair line whose partner design has since been
     removed stops counting. */
  var PAIR_DEFAULT_GBP = { classic: 5.99, gels: 11.99, 'press-ons': 13.99 };
  /* Kit baskets get the kit's own per-design rate (Matt 2026-09-09: a
     kit buyer just paid ~£5 a wrap; £5.99 for one more reads as a step
     up). Classic £39.99 kit ≈ £5.03/wrap spread evenly → £4.99; gel
     £49.99 ≈ £10.07 → £9.99; press-on £59.99 ≈ £11.33 → £10.99. */
  var KIT_PAIR_DEFAULT_GBP = { classic: 4.99, gels: 9.99, 'press-ons': 10.99 };
  function basketHasKitOfTier(cart, tier) {
    return ((cart && cart.items) || []).some(function (it) {
      return isBundleLine(it) && classifyTier(it.product_type) === tier;
    });
  }
  var PAIR_SEEN_KEY = 'hgn_pair_offer_seen';
  function pairCfg(self) { var a = (self.config && self.config.attach) || {}; return a.pair || {}; }
  function pairPriceGbp(self, tier) {
    var cfg = pairCfg(self);
    var kit = basketHasKitOfTier(self.cart, tier);
    var table = kit ? (cfg.kitPrices || {}) : (cfg.prices || {});
    var v = parseFloat(table[tier]);
    if (isFinite(v) && v > 0) return v;
    return kit ? KIT_PAIR_DEFAULT_GBP[tier] : PAIR_DEFAULT_GBP[tier];
  }
  /* Per-currency prices (Stage 2, 2026-09-09). Presentment prices are FIXED
     per market (a £7.99 wrap is €14.95 / $9.00 / A$16.00), so the pair price
     must be set per currency too — announcement bar textareas, one currency
     per line: "EUR 10.99 21.99 24.99" = classic, gels, press-ons. A currency
     with no line gets NO offer (never a converted GBP figure). */
  var TIER_ORDER = ['classic', 'gels', 'press-ons'];
  var priceTableCache = {};
  function parsePriceTable(raw) {
    var key = String(raw || '');
    if (priceTableCache[key]) return priceTableCache[key];
    var out = {};
    key.split(/\r?\n/).forEach(function (line) {
      var parts = line.trim().split(/[\s\/:;,|]+/).filter(Boolean);
      if (parts.length < 2 || !/^[A-Za-z]{3}$/.test(parts[0])) return;
      var cur = parts[0].toUpperCase(), row = {};
      TIER_ORDER.forEach(function (t, i) {
        var v = parseFloat(parts[i + 1]);
        if (isFinite(v) && v > 0) row[t] = Math.round(v * 100);
      });
      out[cur] = row;
    });
    priceTableCache[key] = out;
    return out;
  }
  /* The pair price in presentment cents for this cart's currency, or null
     when the currency has no configured price for the tier. */
  function pairPricePres(self, tier) {
    var cur = String((self.cart && self.cart.currency) || 'GBP').toUpperCase();
    if (cur === 'GBP') return Math.round(pairPriceGbp(self, tier) * 100);
    var cfg = pairCfg(self);
    var kit = basketHasKitOfTier(self.cart, tier);
    var row = kit ? (parsePriceTable(cfg.kitByCurrency)[cur] || parsePriceTable(cfg.byCurrency)[cur]) : parsePriceTable(cfg.byCurrency)[cur];
    var v = row && row[tier];
    return (isFinite(v) && v > 0) ? v : null;
  }
  function activeRate() {
    var k = (typeof H.activeKey === 'function') ? H.activeKey() : 'gbp';
    if (k === 'gbp') return 1;
    return (window.HGN && window.HGN.fxRates && window.HGN.fxRates[k]) || 0;
  }
  function readViewed() {
    try {
      var root = document.querySelector('[data-hgn-viewed]');
      var cid = (root && root.getAttribute('data-customer-id')) || (window.HGN_CUSTOMER_ID ? String(window.HGN_CUSTOMER_ID) : '') || 'anon';
      var keys = ['hgn-viewed:' + cid];
      if (cid !== 'anon') keys.push('hgn-viewed:anon');
      var out = [];
      keys.forEach(function (k) {
        var raw = localStorage.getItem(k);
        if (!raw) return;
        var arr = JSON.parse(raw);
        if (Array.isArray(arr)) out = out.concat(arr);
      });
      return out;
    } catch (e) { return []; }
  }
  /* "Seen" is per OFFER signature — the cart signature (`item_count:total`)
     plus the sorted design handles — and expires after 30 minutes. The
     bare cart signature collides across every one-wrap basket, so a
     decline this morning silently killed every later one-wrap offer in
     the same tab (Matt's M1 re-test, 2026-09-09). */
  var PAIR_SEEN_MS = 30 * 60 * 1000;
  function pairSeen(sig) {
    try {
      var v = JSON.parse(sessionStorage.getItem(PAIR_SEEN_KEY) || 'null');
      return !!(v && v.sig === sig && (Date.now() - (v.at || 0)) < PAIR_SEEN_MS);
    } catch (e) { return false; }
  }
  function markPairSeen(sig) {
    try { sessionStorage.setItem(PAIR_SEEN_KEY, JSON.stringify({ sig: sig, at: Date.now() })); } catch (e) {}
  }
  /* Basket signature that also names the designs, so swapping one £7.99
     wrap for another is a different basket (audit P2: collisions). */
  HGNSideCart.prototype._offerSignature = function () {
    var base = (typeof this._cartSignature === 'function') ? this._cartSignature() : '';
    var hs = [];
    ((this.cart && this.cart.items) || []).forEach(function (it) { if (it && it.handle && !isGiftLineItem(it)) hs.push(lc(it.handle)); });
    hs.sort();
    return base + ':' + hs.join(',');
  };
  /* One console line per signature saying WHY there was no card — the
     question every manual test asks. Also exposed as window.HGN.offersDebug(). */
  HGNSideCart.prototype._noOffer = function (reason, extra) {
    var sig = this._offerSignature();
    this._noOfferLog = this._noOfferLog || {};
    this._lastNoOffer = { reason: reason, extra: extra || null, sig: sig };
    if (this._noOfferLog[sig] === reason) return;
    this._noOfferLog[sig] = reason;
    try { if (window.console && console.info) console.info('[hgn-side-cart-attach] no offer: ' + reason, extra ? JSON.stringify(extra) : ''); } catch (e) {}
  };
  function lineProp(it, name) { var p = it && it.properties; return p ? (p[name] != null ? p[name] : '') : ''; }
  /* Offer lines: a PAIR line (second design at the pair price) or a
     FREE-4TH line (Matt's rule, 2026-09-08: at two designs, add a third
     and the fourth is free — the free line is the one WE add, so nobody
     arriving with four gets anything free). Both carry
     `_hgn_offer_gbp_cents` / `_hgn_offer_pres_cents` (the saving) and
     `_hgn_offer_kind` = 'pair' | 'free4'. */
  function offerKind(it) { return lineProp(it, '_hgn_offer_kind'); }
  function isOfferLine(it) { return !!offerKind(it); }
  /* Offer lines still backed by their partners: a pair line needs ≥1
     other design line of its tier; a free-4th line needs ≥3 paid
     design UNITS of its tier. */
  /* Audit 2026-09-09 P1-1: offers are a DEFAULT-intent mechanic. Nail
     Points and ad-hoc codes take their own checkout paths and neither mints
     our saving, so an existing offer line must stop folding the moment the
     intent flips — otherwise the drawer promises money the mint never
     carries. Same two signals as _isNailPointsActive / _getDiscountIntent. */
  function offersSuspended(cart) {
    var a = (cart && cart.attributes) || {};
    var v = a._hgn_discount_intent || a['_hgn_discount_intent'];
    if (v === 'nailpoints' || v === 'adhoc') return true;
    return ((cart && cart.discount_codes) || []).some(function (d) {
      return d && d.code && (/^NAILPOINTS-/i.test(d.code) || /^BEANS-/i.test(d.code));
    });
  }
  function activeOfferLines(cart) {
    if (offersSuspended(cart)) return [];
    var items = (cart && cart.items) || [];
    var tierLines = {}, tierUnits = {};
    items.forEach(function (it) {
      if (isGiftLineItem(it) || isOfferLine(it)) return;
      var t = classifyTier(it.product_type);
      if (!t || t === 'accessories') return;
      tierLines[t] = (tierLines[t] || 0) + 1;                       /* kit designs count as partners */
      if (!isBundleLine(it)) tierUnits[t] = (tierUnits[t] || 0) + (it.quantity || 0);
    });
    /* A pair line (paid) also counts as a paid unit for a free4 partner check. */
    items.forEach(function (it) {
      if (offerKind(it) !== 'pair') return;
      var t = classifyTier(it.product_type);
      if (t) tierUnits[t] = (tierUnits[t] || 0) + (it.quantity || 0);
    });
    return items.filter(function (it) {
      var kind = offerKind(it);
      if (!kind) return false;
      var t = classifyTier(it.product_type);
      if (!t) return false;
      if (kind === 'free4') return (tierUnits[t] || 0) >= 3;
      return (tierLines[t] || 0) >= 1;
    });
  }
  /* The saving is re-derived from the LIVE line price at fold time (retail
     side never from a snapshot — SIDE-CART.md §15). One unit per offer line:
     pair = unit retail − stored pair price; free4 = unit retail. Falls back
     to the frozen figures only when the line carries no price. */
  function unitRetail(it) {
    var q = Math.max(1, it.quantity || 1);
    var r = it.original_line_price != null ? it.original_line_price : (it.line_price || 0);
    return Math.round(r / q);
  }
  function offerSavePres(it) {
    var stored = parseInt(lineProp(it, '_hgn_offer_pres_cents'), 10) || 0;
    var ur = unitRetail(it);
    if (!ur) return stored;
    if (offerKind(it) === 'free4') return ur;
    var pp = parseInt(lineProp(it, '_hgn_offer_pair_pres'), 10);
    if (!isFinite(pp) || pp <= 0) return Math.min(stored, ur);
    return Math.max(0, ur - pp);
  }
  function offerSaveGbp(it) {
    var r = activeRate();
    if (!r) return parseInt(lineProp(it, '_hgn_offer_gbp_cents'), 10) || 0;
    return Math.round(offerSavePres(it) / r);
  }
  function pairGbpCents(cart) { return activeOfferLines(cart).reduce(function (s, it) { return s + offerSaveGbp(it); }, 0); }
  function pairPresCents(cart) { return activeOfferLines(cart).reduce(function (s, it) { return s + offerSavePres(it); }, 0); }
  /* Runs per tier, tier-matched: classics with classics, gels with
     gels, press-ons with press-ons (Matt 2026-09-08). `tiers` is a
     comma list; default all three. */
  function free4Cfg(self) {
    var a = (self.config && self.config.attach) || {};
    var f = a.free4 || {};
    var tiers = String(f.tiers || 'classic,gels,press-ons').split(',').map(function (t) { return t.trim(); }).filter(Boolean);
    return { enabled: f.enabled !== false, tiers: tiers };
  }

  /* Candidate sources, in order (Matt 2026-09-08: "recently viewed,
     wishlist, or a curated item using PI"): 1) recently viewed
     (localStorage, sync), 2) wishlist (worker GET for signed-in
     shoppers, hgn_wishlist_temp for guests), 3) Complete-the-Look
     (worker POST, the same call the kit upsell makes). Normalised to
     { handle, title, image, variantId, retailPres, source }.
     Resolved ahead of the tap: _render kicks off _prefetchPairCandidate
     per basket signature, so the Checkout tap is usually synchronous. */
  function parsePriceToPres(raw) {
    if (raw == null) return 0;
    if (typeof raw === 'number') return raw >= 100 ? Math.round(raw) : Math.round(raw * 100);
    var str = String(raw).replace(/[^0-9.]/g, '');
    if (!str) return 0;
    if (str.indexOf('.') !== -1) return Math.round(parseFloat(str) * 100);
    return parseInt(str, 10) || 0;
  }
  /* Kit (bundle) design lines COUNT for tier detection and as CTL seeds
     — a kit on its own gets a pair offer in its tier (Matt 2026-09-09:
     "nothing wrong with incrementing kit orders with a discounted
     wrap"). `units` stays standalone-only: the third-plus-free rule is
     about paid standalone designs. */
  function basketTierInfo(cart) {
    var tierLines = {}, tierUnits = {}, handles = {}, tierHandles = {};
    ((cart && cart.items) || []).forEach(function (it) {
      if (it.handle) handles[lc(it.handle)] = true;
      if (isGiftLineItem(it) || isOfferLine(it)) return;
      var t = classifyTier(it.product_type);
      if (!t || t === 'accessories') return;
      tierLines[t] = (tierLines[t] || 0) + 1;
      if (!isBundleLine(it)) tierUnits[t] = (tierUnits[t] || 0) + (it.quantity || 0);
      (tierHandles[t] = tierHandles[t] || []).push(it.handle);
    });
    var tier = null, best = 0;
    Object.keys(tierLines).forEach(function (t) { if (tierLines[t] > best) { best = tierLines[t]; tier = t; } });
    return { tier: tier, handles: handles, tierHandles: tierHandles[tier] || [], units: tierUnits[tier] || 0 };
  }
  function usableDesign(v, tier, handles) {
    if (!v || v.available === false || !v.handle) return false;
    if (v.tier && lc(v.tier) !== tier) return false;
    if (!v.tier && v.productType && classifyTier(v.productType) !== tier) return false;
    if (handles[lc(v.handle)]) return false;
    var h = lc(v.handle), t = lc(v.title);
    if (h.indexOf('starter-kit') !== -1 || h.indexOf('starter_kit') !== -1) return false;
    if (t.indexOf('pack') !== -1 || t.indexOf('matching tips') !== -1 || t.indexOf('mystery') !== -1) return false;
    return true;
  }
  function fromViewed(tier, handles) {
    return readViewed().filter(function (x) { return usableDesign(x, tier, handles) && x.variantId; }).map(function (v) {
      var pres = parseInt(v.priceRaw, 10);
      if (!isFinite(pres) || pres <= 0) return null;
      return { handle: v.handle, title: v.title, image: v.image, variantId: v.variantId, retailPres: pres, source: 'viewed' };
    }).filter(Boolean);
  }
  function fromWishlist(tier, handles) {
    var cid = window.HGN_CUSTOMER_ID ? String(window.HGN_CUSTOMER_ID) : '';
    var pick = function (wl) {
      var arr = (wl && wl[tier]) || [];
      return arr.filter(function (x) { return usableDesign(x, tier, handles) && x.variantId; }).map(function (v) {
        var pres = parsePriceToPres(v.price);
        if (pres <= 0) return null;
        return { handle: v.handle, title: v.title, image: v.image, variantId: v.variantId, retailPres: pres, source: 'wishlist' };
      }).filter(Boolean);
    };
    if (!cid) {
      try {
        var raw = localStorage.getItem('hgn_wishlist_temp');
        var tmp = raw ? JSON.parse(raw) : null;
        return Promise.resolve(pick(tmp && tmp.wishlist));
      } catch (e) { return Promise.resolve([]); }
    }
    return fetch('https://wishlist.holygrailnail.com/api/wishlist/' + encodeURIComponent(cid), { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { return pick(d && d.wishlist); })
      .catch(function () { return []; });
  }
  function fromCtl(tier, handles, tierHandles) {
    if (!tierHandles.length) return Promise.resolve([]);
    var wh = window.HGN_WAREHOUSES || {};
    return fetch('https://holygrailnail.co/api/complete-the-look', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'omit',
      body: JSON.stringify({ productHandles: tierHandles.slice(0, 5), tier: tier, warehouses: { airbox: wh.airbox !== false, portless: wh.portless !== false } })
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var recs = (d && d.ok && Array.isArray(d.recommendations)) ? d.recommendations : [];
        return recs.filter(function (x) { return usableDesign(x, tier, handles) && x.variantId; }).map(function (v) {
          /* Worker prices are shop-currency GBP (Admin API) — convert. */
          var pres = (typeof H.gbpToActiveCents === 'function') ? H.gbpToActiveCents(parseFloat(v.price) || 0) : Math.round((parseFloat(v.price) || 0) * 100);
          if (pres <= 0) return null;
          return { handle: v.handle, title: v.title, image: v.image, variantId: v.variantId, retailPres: pres, source: 'ctl' };
        }).filter(Boolean);
      })
      .catch(function () { return []; });
  }
  /* Every ladder source carries a price we cannot trust at the money moment:
     recently-viewed is a presentment snapshot with no currency and no TTL,
     the wishlist is a bare string shared across all four market domains,
     and CTL prices are shop-currency GBP. Re-read the design from the
     storefront the shopper is actually on before quoting it — one cached
     same-origin GET per candidate, also the freshest stock signal we have. */
  var liveCache = {};
  function liveProduct(handle) {
    var h = lc(handle);
    if (liveCache[h] === undefined) {
      liveCache[h] = fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return Promise.resolve(liveCache[h]);
  }
  function verifyDesigns(list) {
    return Promise.all((list || []).map(function (d) {
      return liveProduct(d.handle).then(function (p) {
        if (!p || p.available === false || !Array.isArray(p.variants)) return null;
        var v = null, i;
        for (i = 0; i < p.variants.length; i++) {
          if (String(p.variants[i].id) === String(d.variantId)) { v = p.variants[i]; break; }
        }
        if (!v || v.available === false) v = p.variants.filter(function (x) { return x && x.available !== false; })[0] || null;
        if (!v || !(v.price > 0)) return null;
        d.variantId  = v.id;
        d.retailPres = v.price;                 /* presentment cents, THIS market, now */
        d.title      = p.title || d.title;
        d.image      = d.image || p.featured_image || '';
        d.verified   = true;
        return d;
      });
    })).then(function (a) { return a.filter(Boolean); });
  }
  /* Up to n distinct designs, ladder order, deduped by handle, each one
     verified live. Only walks to the next source when the previous ones
     came up short. */
  function collectDesigns(tier, handles, tierHandles, n) {
    var out = [], seen = {};
    var take = function (list) {
      (list || []).forEach(function (d) {
        if (out.length >= n || !d || seen[lc(d.handle)]) return;
        seen[lc(d.handle)] = true;
        out.push(d);
      });
    };
    take(fromViewed(tier, handles));
    if (out.length >= n) return verifyDesigns(out);
    return fromWishlist(tier, handles).then(function (w) {
      take(w);
      if (out.length >= n) return verifyDesigns(out);
      return fromCtl(tier, handles, tierHandles).then(function (c) { take(c); return verifyDesigns(out); });
    });
  }

  /* Money maths + guards on a normalised design. null = no offer. */
  HGNSideCart.prototype._pairFromDesign = function (tier, d) {
    if (!d || !d.verified) return null;
    var pairPres = pairPricePres(this, tier);
    if (pairPres == null) return null;
    var savePres = d.retailPres - pairPres;
    if (savePres <= 0) return null;
    var rate = activeRate();
    if (!rate) return null;
    /* GBP pence for the worker's canonical figure; on non-GBP markets the
       worker mints a PERCENTAGE from the presentment pair, so this is the
       logged/fallback value only. */
    var saveGbp = Math.round(savePres / rate);
    if (saveGbp <= 0) return null;
    /* Threshold guard — never let the discount undo a celebrated unlock.
       Only a threshold the drawer has ALREADY celebrated can be undone; a
       basket still under it is simply not lifted over (all-tiers harness
       2026-09-09: the raw-total form refused every gel free-fourth at two
       units, £31.98 → £63.96 raw / £47.97 net vs the £50 gift). */
    var after = (this._lastDisplayedSubtotalCents || 0) + d.retailPres;
    var ctx = this._attachContext();
    if (ctx) {
      if (ctx.shipUnlocked && after >= ctx.shipCents && after - savePres < ctx.shipCents) return null;
      if (ctx.giftUnlocked && ctx.giftCents && after >= ctx.giftCents && after - savePres < ctx.giftCents) return null;
    }
    return { tier: tier, item: d, retailPres: d.retailPres, pairPres: pairPres, savePres: savePres, saveGbp: saveGbp };
  };

  /* Free 4th: A is paid at retail, B is free. Saving = B's retail. */
  HGNSideCart.prototype._free4FromDesigns = function (tier, a, b) {
    if (!a || !b || !a.verified || !b.verified) return null;
    var rate = activeRate();
    if (!rate) return null;
    var saveGbp = Math.round(b.retailPres / rate);
    if (saveGbp <= 0) return null;
    var after = (this._lastDisplayedSubtotalCents || 0) + a.retailPres + b.retailPres;
    var ctx = this._attachContext();
    if (ctx) {
      if (ctx.shipUnlocked && after >= ctx.shipCents && after - b.retailPres < ctx.shipCents) return null;
      if (ctx.giftUnlocked && ctx.giftCents && after >= ctx.giftCents && after - b.retailPres < ctx.giftCents) return null;
    }
    return { kind: 'free4', tier: tier, item: a, free: b, retailPres: a.retailPres, pairPres: a.retailPres, savePres: b.retailPres, saveGbp: saveGbp };
  };

  /* Offer lifecycle → DOM events + Clarity tags, so HQ/Clarity get a
     DENOMINATOR (offers shown) and not just accepted lines. */
  function offerEvent(name, detail) {
    try { document.dispatchEvent(new CustomEvent('hgn:offer:' + name, { detail: detail || {} })); } catch (e) {}
    try {
      if (typeof window.clarity === 'function') {
        window.clarity('set', 'hgn_offer_' + name, String((detail && (detail.kind || detail.reason)) || '1'));
      }
    } catch (e) {}
    try { if (window.console && console.info) console.info('[hgn-side-cart-attach] offer:' + name, JSON.stringify(detail || {})); } catch (e) {}
  }

  /* Cheap pre-checks that need no network. */
  HGNSideCart.prototype._pairEligible = function () {
    var cart = this.cart;
    if (!cart || !cart.item_count) return null;
    if (pairCfg(this).enabled === false) { this._noOffer('pair offer disabled in the announcement bar'); return null; }
    /* Audit 2026-09-09 P0-1: presentment prices are FIXED per market (a £7.99
       wrap is US 900 / EU 1495 / CHF 1400 / SEK 15900), not FX conversions,
       and czk/dkk/pln/ron/sek fold to 'gbp' in activeKey — so every non-GBP
       saving this snippet can compute is wrong somewhere. GBP carts only
       until candidates are re-priced from /products/<handle>.js. */
    var cur = String(cart.currency || 'GBP').toUpperCase();
    var fxKey = ((typeof H.activeKey === 'function') ? H.activeKey() : 'gbp').toUpperCase();
    if (cur !== fxKey) { this._noOffer('currency not supported: ' + cur); return null; }   /* czk/dkk/pln/ron/sek fold to GBP in activeKey */
    if ((cart.items || []).some(isOfferLine)) { this._noOffer('an offer line is already in the basket'); return null; }   /* one offer per order */
    var intent = null;
    try { intent = this._getDiscountIntent(); } catch (e) {}
    if (intent === 'nailpoints' || intent === 'adhoc') { this._noOffer('discount intent is ' + intent); return null; }
    var info = basketTierInfo(cart);
    if (!info.tier) { this._noOffer('no design tier in the basket'); return null; }
    if (pairPricePres(this, info.tier) == null) { this._noOffer('no pair price for ' + cur + ' / ' + info.tier); return null; }
    try {
      var kp = window.HGN && window.HGN.kitProgress;
      if (kp && typeof kp.isTierEnabled === 'function' && !kp.isTierEnabled(info.tier)) { this._noOffer('tier disabled in this market: ' + info.tier); return null; }
    } catch (e) {}
    return info;
  };

  /* Resolve the ladder for the current basket signature, once. */
  HGNSideCart.prototype._prefetchPairCandidate = function () {
    var self = this;
    var sig = this._offerSignature();
    if (this._pairPrefetch && this._pairPrefetch.sig === sig) return this._pairPrefetch.promise;
    var info = this._pairEligible();
    var entry = { sig: sig, result: undefined, promise: null };
    this._pairPrefetch = entry;
    if (!info) { entry.result = null; entry.promise = Promise.resolve(null); return entry.promise; }
    /* Mechanic by paid design units in the tier (Matt 2026-09-08):
       exactly TWO → "add a third, fourth free" (needs two designs);
       otherwise → one more at the pair price. */
    var f4 = free4Cfg(this);
    var wantFree4 = f4.enabled && f4.tiers.indexOf(info.tier) !== -1 && info.units === 2;
    var want = wantFree4 ? 2 : 1;
    entry.promise = collectDesigns(info.tier, info.handles, info.tierHandles, want + 2).then(function (list) {
      offerEvent('resolved', { tier: info.tier, units: info.units, wantFree4: wantFree4, designs: list.map(function (d) { return d.handle + '@' + d.source; }) });
      var cand = null, i;
      if (wantFree4) { for (i = 0; i + 1 < list.length && !cand; i++) cand = self._free4FromDesigns(info.tier, list[i], list[i + 1]); }
      for (i = 0; i < list.length && !cand; i++) cand = self._pairFromDesign(info.tier, list[i]);
      if (cand && !cand.kind) cand.kind = 'pair';
      if (!cand) self._noOffer(list.length ? 'no candidate passed the maths (price ≤ pair price, or a threshold guard)' : 'no candidate design (nothing viewed / wishlisted / recommended in tier ' + info.tier + ' that is not already in the basket)', { tier: info.tier, tried: list.map(function (d) { return d.handle + '@' + d.source; }) });
      if (entry === self._pairPrefetch) entry.result = cand;
      return cand;
    }).catch(function () { if (entry === self._pairPrefetch) entry.result = null; return null; });
    return entry.promise;
  };

  HGNSideCart.prototype._hidePairOffer = function () {
    if (this._pairEl) { this._pairEl.hidden = true; this._pairEl.innerHTML = ''; }
    this._pairOfferOpen = false;
    this._pairOfferSig = null;
  };

  /* Threshold-aware suffix (Matt, 2026-09-09): if taking the offer lifts the
     discounted subtotal over free shipping / the free gift, say so. The
     guard in _pairFromDesign already refuses an offer that would DROP a
     celebrated threshold; crossing UP is good news worth printing. */
  HGNSideCart.prototype._offerUnlockCopy = function (cand) {
    try {
      var ctx = this._attachContext();
      if (!ctx) return '';
      var after = (this._lastDisplayedSubtotalCents || 0) + (cand.retailPres || 0) + (cand.free ? cand.free.retailPres : 0) - (cand.savePres || 0);
      if (!ctx.shipUnlocked && after >= ctx.shipCents) return ' · and <strong>free shipping</strong> is yours';
      if (ctx.shipUnlocked && ctx.giftCents && !ctx.giftUnlocked && ctx.giftName && after >= ctx.giftCents) return ' · and your free <strong>' + escapeHtml(ctx.giftName) + '</strong> is on us';
    } catch (e) {}
    return '';
  };

  /* The offer card (Matt, 2026-09-09 review of M1–M4): it sits ABOVE the
     Checkout button, which stays put and keeps its label — no swapped CTA,
     no auto-continue. The card has its own Add button; the shopper then
     checks out when they are ready, and the accepted line is folded by the
     ordinary render/mint path (so the post-accept settle race is gone too).
     Shown as soon as a candidate resolves while the drawer is open; hidden
     once per basket signature after Add / No thanks. */
  HGNSideCart.prototype._showPairOffer = function (cand, sig) {
    var self = this;
    if (!this.footEl || !this.checkoutBtn || !cand) return false;
    if (this.checkoutBtn.hidden) return false;            /* kit CTA owns the foot */
    var host = this._pairEl;
    if (!host) {
      host = document.createElement('div');
      host.className = 'hgn-side-cart__pair';
      host.setAttribute('data-hgn-side-cart-pair', '');
      host.setAttribute('role', 'group');
      host.setAttribute('aria-label', 'One more thing');
      host.setAttribute('aria-live', 'polite');
      this.footEl.insertBefore(host, this.checkoutBtn);
      this._pairEl = host;
    }
    /* The threshold suffix depends on the DISCOUNTED subtotal, which can
       land a beat after the card first draws (welcome/flow code auto-
       apply, ad-hoc preview). Same basket + same suffix → already up;
       same basket + different suffix → redraw, so "free shipping is
       yours" cannot outlive the maths that produced it (Matt, 2026-09-09:
       card promised free shipping at £27.97 against a £40 threshold). */
    var unlock = this._offerUnlockCopy(cand);
    if (this._pairOfferOpen && this._pairOfferSig === sig && this._pairOfferUnlock === unlock && !host.hidden) return true;   /* already up */
    var cur = this.cart.currency;
    var v = cand.item;
    var thumb = function (d) {
      return '<span class="hgn-side-cart__pair-thumb">' + (d && d.image ? '<img src="' + escapeHtml(d.image) + '" alt="" width="56" height="56">' : '') + '</span>';
    };
    var html;
    if (cand.kind === 'free4') {
      var f = cand.free;
      html =
        '<p class="hgn-side-cart__pair-eyebrow">One more thing</p>' +
        '<div class="hgn-side-cart__pair-row">' +
          '<span class="hgn-side-cart__pair-thumbs">' + thumb(v) + thumb(f) + '</span>' +
          '<span class="hgn-side-cart__pair-body">' +
            '<span class="hgn-side-cart__pair-title">Add a third and your fourth is on us</span>' +
            '<span class="hgn-side-cart__pair-sub">' + escapeHtml(displayTitle(v.title)) + ' <strong>' + formatMoney(v.retailPres, cur) + '</strong> · ' +
              escapeHtml(displayTitle(f.title)) + ' <s>' + formatMoney(f.retailPres, cur) + '</s> <strong>free</strong>' + unlock + '</span>' +
          '</span>' +
        '</div>' +
        '<div class="hgn-side-cart__pair-actions">' +
          '<button type="button" class="hgn-side-cart__pair-add" data-hgn-pair-add>Add both for ' + formatMoney(v.retailPres, cur) + '</button>' +
          '<button type="button" class="hgn-side-cart__pair-skip" data-hgn-pair-skip>No thanks</button>' +
        '</div>';
    } else {
      var kit = basketHasKitOfTier(this.cart, cand.tier);
      var title = kit
        ? 'Why not add ' + escapeHtml(displayTitle(v.title)) + ' at your kit price?'
        : 'Why not add ' + escapeHtml(displayTitle(v.title)) + ' for ' + formatMoney(cand.savePres, cur) + ' off?';
      html =
        '<p class="hgn-side-cart__pair-eyebrow">One more thing</p>' +
        '<div class="hgn-side-cart__pair-row">' +
          thumb(v) +
          '<span class="hgn-side-cart__pair-body">' +
            '<span class="hgn-side-cart__pair-title">' + title + '</span>' +
            '<span class="hgn-side-cart__pair-sub"><s>' + formatMoney(cand.retailPres, cur) + '</s> <strong>' + formatMoney(cand.pairPres, cur) + '</strong> · same parcel' + unlock + '</span>' +
          '</span>' +
        '</div>' +
        '<div class="hgn-side-cart__pair-actions">' +
          '<button type="button" class="hgn-side-cart__pair-add" data-hgn-pair-add>Add for ' + formatMoney(cand.pairPres, cur) + '</button>' +
          '<button type="button" class="hgn-side-cart__pair-skip" data-hgn-pair-skip>No thanks</button>' +
        '</div>';
    }
    host.innerHTML = html;
    host.hidden = false;
    this._pairOfferOpen = true;
    this._pairOfferSig = sig;
    this._pairOfferUnlock = unlock;
    offerEvent('shown', { kind: cand.kind || 'pair', tier: cand.tier, source: v.source, handle: v.handle, freeHandle: cand.free ? cand.free.handle : null, unlock: unlock ? (unlock.indexOf('shipping') !== -1 ? 'ship' : 'gift') : null });

    var addBtn = host.querySelector('[data-hgn-pair-add]');
    var skipBtn = host.querySelector('[data-hgn-pair-skip]');
    skipBtn.addEventListener('click', function () {
      offerEvent('declined', { kind: cand.kind || 'pair', tier: cand.tier });
      markPairSeen(sig);
      self._hidePairOffer();
    });
    addBtn.addEventListener('click', function () {
      if (self._pairInflight) return;
      self._pairInflight = true;
      addBtn.disabled = true; skipBtn.disabled = true;
      addBtn.textContent = 'Adding…';
      var items;
      if (cand.kind === 'free4') {
        var f = cand.free;
        var paidProps = {}, freeProps = {};
        paidProps['_hgn_src'] = 'checkout_free4:' + cand.tier + ':' + (v.source || 'viewed') + ':paid';
        freeProps['_hgn_src'] = 'checkout_free4:' + cand.tier + ':' + (f.source || 'viewed') + ':free';
        freeProps['_hgn_offer_kind'] = 'free4';
        freeProps['_hgn_offer_gbp_cents'] = String(cand.saveGbp);
        freeProps['_hgn_offer_pres_cents'] = String(cand.savePres);
        freeProps['_hgn_offer_label'] = 'Free 4th';
        items = [
          { id: parseInt(v.variantId, 10), quantity: 1, properties: paidProps },
          { id: parseInt(f.variantId, 10), quantity: 1, properties: freeProps }
        ];
      } else {
        var props = {};
        props['_hgn_src'] = 'checkout_pair:' + cand.tier + ':' + (v.source || 'viewed');
        props['_hgn_offer_kind'] = 'pair';
        props['_hgn_offer_gbp_cents'] = String(cand.saveGbp);
        props['_hgn_offer_pres_cents'] = String(cand.savePres);
        props['_hgn_offer_pair_pres'] = String(cand.pairPres);
        props['_hgn_offer_label'] = (basketHasKitOfTier(self.cart, cand.tier) ? 'Kit price ' : 'Pair price ') + formatMoney(cand.pairPres, cur);
        items = [{ id: parseInt(v.variantId, 10), quantity: 1, properties: props }];
      }
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) { var e = new Error('pair add ' + r.status); e.status = r.status; throw e; }
        offerEvent('accepted', { kind: cand.kind || 'pair', tier: cand.tier, source: v.source });
        markPairSeen(sig);
        try {
          document.dispatchEvent(new CustomEvent('hgn:attach:add', { detail: { reason: cand.kind === 'free4' ? 'checkout_free4' : 'checkout_pair', slot: cand.tier, variantId: v.variantId, handle: v.handle } }));
        } catch (e) {}
        self._hidePairOffer();
        return self.refresh();
      }).then(function () {
        self._pairInflight = false;
      }).catch(function (err) {
        self._pairInflight = false;
        var status = err && err.status;
        if (status >= 400 && status < 500) {
          /* Sold out since the offer was built — retire it quietly. */
          offerEvent('failed', { kind: cand.kind || 'pair', tier: cand.tier, status: status });
          markPairSeen(sig);
          self._hidePairOffer();
          return;
        }
        addBtn.disabled = false; skipBtn.disabled = false;
        addBtn.textContent = 'Try again';
      });
    });
    return true;
  };

  /* A held POPUP-* code (welcome or email-flow) is about to auto-apply
     the moment the drawer opens — and once it does, the pair offer is
     ineligible (ad-hoc intent). Drawing the card in the gap and then
     pulling it reads as "where did that go?" (Matt, 2026-09-09). So: no
     card while that decision is pending. Bounded at 6 s — a refused code
     (dead / already used) leaves no intent behind, and the card must not
     stay hidden for ever on its account. */
  HGNSideCart.prototype._welcomeApplyPending = function () {
    try {
      var held = (window.HGNPopup && typeof window.HGNPopup.activeCode === 'function') ? window.HGNPopup.activeCode() : null;
      if (!held || !held.code || String(held.code).indexOf('POPUP-') !== 0) return false;
      var intent = null;
      try { intent = this._getDiscountIntent(); } catch (e) {}
      if (intent) return false;                                   /* decided: applied (or another intent won) */
      if (this.cart && (this.cart.total_discount || 0) > 0) return false;
      if (!this._welcomeHoldSince) {
        this._welcomeHoldSince = Date.now();
        var self = this;
        setTimeout(function () { try { if (self.isOpen) self._render(); } catch (e) {} }, 6500);
      }
      return (Date.now() - this._welcomeHoldSince) < 6000;
    } catch (e) { return false; }
  };

  /* Show the resolved candidate while the drawer is open. Runs from the
     _render wrapper after each prefetch settles. */
  HGNSideCart.prototype._maybeShowOffer = function (cand) {
    try {
      if (!cand || !this.isOpen || !this.cart || !this.cart.item_count) return;
      if (this._kitCheckoutPending || this._checkoutMintFailed) return;
      var sig = this._offerSignature();
      var entry = this._pairPrefetch;
      if (!entry || entry.sig !== sig) return;             /* basket moved since */
      if (this._welcomeApplyPending()) { this._noOffer('holding: a held code is about to auto-apply'); return; }
      /* Card already up for THIS basket: keep its threshold line honest.
         The discounted subtotal can move after the first draw (a flow or
         welcome code auto-applying), and the seen-guard below would
         otherwise freeze "free shipping is yours" for 30 minutes (Matt,
         2026-09-09, second report). Redraw only when the suffix changes. */
      var eligible = this._pairEligible();
      if (this._pairOfferOpen && this._pairOfferSig === sig && this._pairEl && !this._pairEl.hidden) {
        /* Eligibility can also flip after the draw — an order code auto-
           applying sets the ad-hoc intent, and the pair price cannot ride
           that checkout path (live repro 2026-09-09: card up, then
           "no offer: discount intent is adhoc", card never taken down). */
        if (!eligible) { this._hidePairOffer(); return; }
        if (this._offerUnlockCopy(cand) !== this._pairOfferUnlock) this._showPairOffer(cand, sig);
        return;
      }
      if (pairSeen(sig)) { this._noOffer('already offered for this basket in the last 30 min', { sig: sig }); return; }
      if (!eligible) return;
      this._showPairOffer(cand, sig);
    } catch (e) {
      if (window.console && console.warn) console.warn('[hgn-side-cart-attach] offer card skipped:', e);
    }
  };

  /* Checkout stays Checkout. The only thing we do on the tap is record an
     implicit decline when the card was still up, so acceptance has a
     denominator that includes the shoppers who simply carried on. */
  var origHandleCheckout = HGNSideCart.prototype._handleCheckout;
  HGNSideCart.prototype._handleCheckout = function () {
    try {
      if (this._pairOfferOpen && this._pairEl && !this._pairEl.hidden) {
        offerEvent('declined', { kind: 'unknown', implicit: true });
      }
    } catch (e) {}
    return origHandleCheckout.apply(this, arguments);
  };

  /* Display + state fold for pair lines (runs inside the _render wrapper). */
  HGNSideCart.prototype._applyPairFold = function () {
    var cart = this.cart;
    if (!cart || !cart.item_count) { this._hidePairOffer(); return; }
    /* Basket moved while the offer was open → the offer is stale. */
    if (this._pairOfferOpen && this._offerSignature() !== this._pairOfferSig) this._hidePairOffer();
    var g = pairGbpCents(cart), p = pairPresCents(cart);
    var f = this._offerFold;
    if (f) {
      /* Back out the previous fold if the base render didn't reset. */
      if (this._lastSavingsGbpCents === f.gbpAfter) this._lastSavingsGbpCents -= f.gbp;
      if (this._lastSavingsCents === f.presAfter) this._lastSavingsCents -= f.pres;
      if (this._lastDisplayedSubtotalCents === f.subAfter) this._lastDisplayedSubtotalCents += f.pres;
      this._offerFold = null;
    }
    if (g <= 0 || p <= 0) {
      /* Offer line present but no longer backed by its partner (or the
         intent flipped): say so — never let the price just climb back. */
      var hasOfferLine = (cart.items || []).some(isOfferLine);
      if (hasOfferLine && !offersSuspended(cart) && this._setCheckoutNote && !this._checkoutMintFailed) {
        this._setCheckoutNote('Your pair price needed the design it was paired with \u2014 it\u2019s back at full price.');
        this._offerLapseNoted = true;
      } else if (this._offerLapseNoted && !this._checkoutMintFailed) {
        this._offerLapseNoted = false;
        if (this._clearCheckoutNote) this._clearCheckoutNote();
      }
      this._reassertPairCard();
      return;
    }
    if (this._offerLapseNoted && !this._checkoutMintFailed) {
      this._offerLapseNoted = false;
      if (this._clearCheckoutNote) this._clearCheckoutNote();
    }
    this._lastSavingsGbpCents = (this._lastSavingsGbpCents || 0) + g;
    this._lastSavingsCents    = (this._lastSavingsCents || 0) + p;
    this._offerFold = { gbp: g, pres: p, gbpAfter: this._lastSavingsGbpCents, presAfter: this._lastSavingsCents, subAfter: null };
    var cur = cart.currency;
    if (this.savingsEl && this.savingsValueEl) {
      /* _lastSavingsCents excludes the KIT5 fold (the base render adds it
         only at paint time) — re-add it or the row drops ~£5 (audit P1-5). */
      var k5 = 0;
      try { if (typeof this._kit5FoldGbpCents === 'function' && typeof H.gbpToActiveCents === 'function') k5 = H.gbpToActiveCents((this._kit5FoldGbpCents() || 0) / 100); } catch (e) {}
      this.savingsValueEl.textContent = formatMoney(this._lastSavingsCents + k5, cur);
      this.savingsEl.hidden = false;
    }
    if (typeof this._lastDisplayedSubtotalCents === 'number') {
      this._lastDisplayedSubtotalCents = Math.max(0, this._lastDisplayedSubtotalCents - p);
      this._offerFold.subAfter = this._lastDisplayedSubtotalCents;
      if (this.subtotalEl) this.subtotalEl.textContent = formatMoney(this._lastDisplayedSubtotalCents, cur);
    }
    /* Row price: retail struck through, pair price beside it. */
    var self = this;
    activeOfferLines(cart).forEach(function (it) {
      var save = offerSavePres(it);
      var kind = offerKind(it);
      if (!save || !self.itemsEl) return;
      var rows = self.itemsEl.querySelectorAll('.hgn-side-cart__item');
      for (var i = 0; i < rows.length; i++) {
        var a = rows[i].querySelector('.hgn-side-cart__item-title');
        if (!a || String(a.getAttribute('href') || '').indexOf('/products/' + it.handle) === -1) continue;
        var priceEl = rows[i].querySelector('.hgn-side-cart__item-price');
        if (!priceEl || priceEl.getAttribute('data-hgn-pair-done')) continue;
        var retail = it.original_line_price != null ? it.original_line_price : (it.line_price || 0);
        priceEl.innerHTML = '<s class="hgn-side-cart__item-price--strike">' + formatMoney(retail, cur) + '</s> ' +
          formatMoney(Math.max(0, retail - save), cur) + ' <span class="hgn-side-cart__item-pair">' + (kind === 'free4' ? '4th free' : 'Pair price') + '</span>';
        priceEl.setAttribute('data-hgn-pair-done', '1');
        break;
      }
    });
    this._reassertPairCard();
  };
  /* Audit 2026-09-09 P1-2: the base _render's _renderMidBuildFoot(false)
     un-hides the checkout row on EVERY render — re-assert while the card is
     up, or a same-signature re-render leaves two CTAs in the foot. */
  HGNSideCart.prototype._reassertPairCard = function () {
    /* The card never hides the Checkout button any more (Matt 2026-09-09);
       the only thing to keep straight is a card whose basket moved on. */
    if (this._pairOfferOpen && this._offerSignature() !== this._pairOfferSig) this._hidePairOffer();
  };


  /* Meter + gift orchestration must see the SAME discounted subtotal
     Shopify will rate shipping on. Both read
     _lastBundleSavingsCents/_lastAdHocSavingsCents at call time, so
     the pair + multibuy presentment savings are lent to
     _lastAdHocSavingsCents around each original call and restored. */
  function withExtraSavings(self, fn, args) {
    var extra = pairPresCents(self.cart) || 0;
    if (!extra) return fn.apply(self, args);
    var prev = self._lastAdHocSavingsCents || 0;
    self._lastAdHocSavingsCents = prev + extra;
    try { return fn.apply(self, args); } finally { self._lastAdHocSavingsCents = prev; }
  }
  var origOrchestrateGift = HGNSideCart.prototype._orchestrateFreeGift;
  if (typeof origOrchestrateGift === 'function') {
    HGNSideCart.prototype._orchestrateFreeGift = function () {
      return withExtraSavings(this, origOrchestrateGift, arguments);
    };
  }


  /* ═══════════ Drawer-open arm test (Matt 2026-09-09) ═══════════
     Arm A (today): the drawer opens on EVERY successful /cart/add.
     Arm B: opens on the FIRST add of the session and whenever an add
     crosses a milestone (free shipping / free gift unlock); otherwise
     a 2.5 s toast ("Added to your bag · View bag") + the badge bump.
     A bag-icon tap always opens. Assignment: localStorage
     `hgn_arm_drawer` (sticky), from config `attach.drawerArm` =
     'A' | 'B' | 'split' (50/50). Recorded as Clarity tag
     `hgn_arm_drawer` and cart attribute `_hgn_arm_drawer` (once per
     cart token) so orders can be split by arm.

     Add detection: the side cart's own fetch interceptor dispatches
     hgn:cart:open right after an add resolves; we stamp the add first
     (our fetch wrapper installs at parse time, under the side cart's),
     so an open() arriving within 2.5 s of a stamp is add-triggered. */
  /* Retired 2026-09-11: the arm registry below derives every family's key as
     'hgn_arm_' + family, so the drawer family's key is still exactly
     'hgn_arm_drawer'. Kept as a named constant so a grep for the live key
     lands somewhere. */
  var ARM_KEY = 'hgn_arm_drawer';   /* eslint-disable-line no-unused-vars */
  var ADD_WINDOW_MS = 4000;
  window.__hgnLastAddAt = window.__hgnLastAddAt || 0;
  if (!window.__hgnAttachAddStamp) {
    window.__hgnAttachAddStamp = true;
    var origFetchStamp = window.fetch;
    window.fetch = function () {
      var url = arguments[0] && (arguments[0].url || arguments[0]);
      try {
        /* Stamp on the REQUEST, not the response — the side cart's own
           interceptor may sit above or below this one depending on load
           order, and its open() must always see the stamp.
           Audit 2026-09-09 P0-3: deliberate multi-line adds (kit finalise,
           replen one-tap basket) and orchestrator adds (gift, bundle) are
           NOT shopper quick-adds — never stamp them, so the open that
           follows always opens. */
        var body = arguments[1] && arguments[1].body;
        var plural = typeof body === 'string' && /"items"\s*:\s*\[/.test(body) && (body.match(/"id"\s*:/g) || []).length > 1;
        var special = typeof body === 'string' && /_bundle_id|_gift_line/.test(body);
        if (typeof url === 'string' && !plural && !special && /\/cart\/add(\.js)?([?#]|$)/.test(url)) window.__hgnLastAddAt = Date.now();
      } catch (e) {}
      return origFetchStamp.apply(this, arguments);
    };
    /* An explicit bag tap is never an add: clear the stamp in the capture
       phase, before the header / app tab bar dispatch their open events. */
    document.addEventListener('click', function (e) {
      try {
        var t = e.target && e.target.closest && e.target.closest('[data-hgn-cart-trigger], [data-hgn-tab="cart"]');
        if (t) window.__hgnLastAddAt = 0;
      } catch (err) {}
    }, true);
  }
  /* ─── Arm registry (generalised 2026-09-11 for the kitnudge family) ───
     One localStorage key, one Clarity tag and one cart attribute per
     family; ALL families are written in a single /cart/update.js pass
     (design doc §C.1). Family three is a registerArm() call, not a new
     fetch. Memoised at module scope (audit 2026-09-09): with storage
     blocked the arm used to re-roll on every render and poison the split. */
  var ARM_MEMO = {};
  var ARM_FAMILIES = [];
  function registerArm(family, cfgKey) {
    for (var i = 0; i < ARM_FAMILIES.length; i++) if (ARM_FAMILIES[i].family === family) return;
    ARM_FAMILIES.push({
      family: family,
      cfgKey: cfgKey,
      key:    'hgn_arm_' + family,
      attr:   '_hgn_arm_' + family
    });
  }
  function armSpec(family) {
    for (var i = 0; i < ARM_FAMILIES.length; i++) if (ARM_FAMILIES[i].family === family) return ARM_FAMILIES[i];
    return null;
  }
  /* `off` is the merchant kill switch: everyone lands in arm A (today's
     behaviour) and nothing is persisted, so flipping back resumes the
     split with the same devices in the same arms. */
  function armFor(self, family) {
    var spec = armSpec(family);
    if (!spec) return 'A';
    var cfg = ((self && self.config && self.config.attach) || {})[spec.cfgKey] || 'split';
    if (cfg === 'A' || cfg === 'B') return cfg;
    if (cfg === 'off') return 'A';
    if (ARM_MEMO[family]) return ARM_MEMO[family];
    var arm = null;
    try { arm = localStorage.getItem(spec.key); } catch (e) {}
    if (arm !== 'A' && arm !== 'B') {
      arm = Math.random() < 0.5 ? 'A' : 'B';
      try { localStorage.setItem(spec.key, arm); } catch (e) {}
    }
    return (ARM_MEMO[family] = arm);
  }
  registerArm('drawer', 'drawerArm');
  function drawerArm(self) { return armFor(self, 'drawer'); }
  /* Wave two (2026-09-11, `kitcurated`) and everything after it register
     through THIS registry — never a forked one. One localStorage key, one
     Clarity tag and one cart attribute per family, all written in the
     single /cart/update.js pass below. `armFor` is exposed with a config
     shim because a caller outside the drawer has no instance: the side
     cart holds window.HGN_SIDE_CART_CONFIG by reference, so reading it
     here is the same object `self.config` would have been. */
  try {
    window.HGN = window.HGN || {};
    window.HGN.registerArm = function (family, cfgKey) { registerArm(family, cfgKey); };
    window.HGN.armFor = function (family) {
      return armFor({ config: window.HGN_SIDE_CART_CONFIG || {} }, family);
    };
  } catch (e) {}
  HGNSideCart.prototype._recordArms = function () {
    var self = this;
    var arms = {}, attrs = {}, dirty = false;
    var cartAttrs = (this.cart && this.cart.attributes) || {};
    this._armTagged = (this._armTagged && typeof this._armTagged === 'object') ? this._armTagged : {};
    ARM_FAMILIES.forEach(function (spec) {
      var arm = armFor(self, spec.family);
      arms[spec.family] = arm;
      try { document.documentElement.setAttribute('data-hgn-arm-' + spec.family, arm); } catch (e) {}
      if (self._armTagged[spec.family] !== arm) {
        self._armTagged[spec.family] = arm;
        try { if (typeof window.clarity === 'function') window.clarity('set', spec.key, arm); } catch (e) {}
      }
      if (cartAttrs[spec.attr] !== arm) { attrs[spec.attr] = arm; dirty = true; }
    });
    try { window.HGN = window.HGN || {}; window.HGN.arms = arms; } catch (e) {}
    /* Cart attributes once per cart token PER ARM SET — only when there's
       a cart. Keying on the token alone (the original) meant a cart that
       had been stamped once could never be re-stamped, so flipping the
       kill switch left every in-flight basket carrying the old arm in D1
       while the shopper was already getting the new one (review P1-3).
       Arms are stable per device, so this is still one write per cart in
       the normal case; the extra write happens only when an arm really
       changes. */
    try {
      var token = this.cart && this.cart.token;
      var sig = token + '|' + ARM_FAMILIES.map(function (s) { return s.family + '=' + arms[s.family]; }).join(',');
      if (token && this.cart.item_count && dirty && this._armAttrSig !== sig) {
        this._armAttrSig = sig;
        this._armAttrToken = token;
        fetch('/cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: attrs })
        }).catch(function () {});
      }
    } catch (e) {}
    return arms.drawer;
  };
  /* Back-compat alias — the _render wrapper below and any probe calling
     _recordArm() keeps working. */
  HGNSideCart.prototype._recordArm = function () { return this._recordArms(); };
  HGNSideCart.prototype._showAddedToast = function () {
    var self = this;
    var el = this._toastEl;
    if (!el) {
      el = document.createElement('div');
      el.className = 'hgn-side-cart__toast';
      el.setAttribute('role', 'status');
      el.innerHTML = '<span class="hgn-side-cart__toast-text">Added to your bag</span>' +
        '<button type="button" class="hgn-side-cart__toast-cta" data-hgn-toast-view>View bag</button>';
      document.body.appendChild(el);
      el.querySelector('[data-hgn-toast-view]').addEventListener('click', function () {
        el.classList.remove('is-on');
        self._forceOpen = true;
        try { self.open(); } finally { self._forceOpen = false; }
      });
      this._toastEl = el;
    }
    el.classList.add('is-on');
    clearTimeout(this._toastTimer);
    this._toastTimer = setTimeout(function () { el.classList.remove('is-on'); }, 2500);
    offerEvent('toast', { kind: 'added' });
  };
  var origOpen = HGNSideCart.prototype.open;
  HGNSideCart.prototype.open = function () {
    var self = this;
    try {
      var addTriggered = !this._forceOpen && (Date.now() - (window.__hgnLastAddAt || 0)) < ADD_WINDOW_MS;
      if (!addTriggered || this.isOpen) return origOpen.apply(this, arguments);
      var arm = this._recordArm();
      /* One add → one add-triggered open (audit 2026-09-09 P0-3). Once the
         decision is taken the stamp is spent, so a bag tap a second later
         is a bag tap. */
      var consume = function () { window.__hgnLastAddAt = 0; };
      if (arm !== 'B') { consume(); return origOpen.apply(this, arguments); }
      /* Arm B: first add of the session opens; later adds open only on a milestone. */
      var first = false;
      try { first = !sessionStorage.getItem('hgn_drawer_first_add_open'); if (first) sessionStorage.setItem('hgn_drawer_first_add_open', '1'); } catch (e) { first = true; }
      if (first) { consume(); offerEvent('drawer_open', { reason: 'first_add' }); return origOpen.apply(this, arguments); }
      var prev = this._lastMilestones || { ship: false, gift: false };
      var args = arguments;
      if (this._armDecisionInflight) return;
      this._armDecisionInflight = true;
      Promise.resolve(this.refresh()).catch(function () {}).then(function () {
        self._armDecisionInflight = false;
        consume();
        var now = self._lastMilestones || { ship: false, gift: false };
        var crossed = (!prev.ship && now.ship) || (!prev.gift && now.gift);
        if (crossed) { offerEvent('drawer_open', { reason: 'milestone' }); origOpen.apply(self, args); }
        else self._showAddedToast();
      });
      return;
    } catch (e) {
      return origOpen.apply(this, arguments);
    }
  };

  /* Manual-test aid: window.HGN.offersDebug() → why the card is or isn't up. */
  try {
    window.HGN = window.HGN || {};
    window.HGN.offersDebug = function () {
      var sc = window.HGN.sideCart, inst = null;
      try { inst = sc && sc.__hgnInstance ? sc.__hgnInstance : null; } catch (e) {}
      var out = { note: 'see console lines "[hgn-side-cart-attach] no offer: …" and "offer:resolved"' };
      try { out.seen = JSON.parse(sessionStorage.getItem(PAIR_SEEN_KEY) || 'null'); } catch (e) {}
      try { out.viewed = readViewed().map(function (v) { return v.handle; }); } catch (e) {}
      if (inst) { out.lastNoOffer = inst._lastNoOffer || null; out.cardOpen = !!inst._pairOfferOpen; }
      return out;
    };
  } catch (e) {}

  /* ─── wrap the render pipeline (no edits to the main file) ─── */
  var origRenderUpsell = HGNSideCart.prototype._renderUpsell;
  HGNSideCart.prototype._renderUpsell = function (groups) {
    var out;
    try { out = origRenderUpsell.apply(this, arguments); } catch (e) { throw e; }
    try { this._renderAttach(groups); } catch (e) {
      if (window.console && console.warn) console.warn('[hgn-side-cart-attach]', e);
    }
    return out;
  };

  /* Ladder-early: below the shipping threshold, the meter copy only
     narrates shipping — the gift milestone icon is on the track but the
     words never mention it. Append one muted line so the whole ladder
     reads at a glance. Skipped when Nail Points intent is active (gift
     is off the table), when no gift is configured, or once shipping is
     unlocked (the original copy already names the gift then). */
  var origRenderProgress = HGNSideCart.prototype._renderProgress;
  HGNSideCart.prototype._renderProgress = function () {
    var out = withExtraSavings(this, origRenderProgress, arguments);
    try {
      var cfg = (this.config && this.config.attach) || {};
      if (cfg.ladderEarly === false || !this.progressLineEl || !this.cart) return out;
      var ctx = this._attachContext();
      if (!ctx || ctx.shipUnlocked || !ctx.giftCents || !ctx.giftName) return out;
      var next = document.createElement('span');
      next.className = 'hgn-side-cart__progress-next';
      next.innerHTML = 'then a free <strong>' + escapeHtml(ctx.giftName) + '</strong> at ' +
        formatMoney(ctx.giftCents, this.cart.currency);
      this.progressLineEl.appendChild(next);
    } catch (e) {}
    return out;
  };

  /* Empty-cart path never calls _renderUpsell; make sure a stale row
     from the previous basket doesn't linger. */
  /* Audit 2026-09-09 P1-6: the main file's pageshow reset can't know our
     in-flight flags; a bfcache restore with one frozen true wedged the
     drawer shut. The main handler calls refresh() → _render, so reset here. */
  var RESTORED = false;
  try { window.addEventListener('pageshow', function (e) { if (e && e.persisted) RESTORED = true; }); } catch (e) {}
  var origRender = HGNSideCart.prototype._render;
  HGNSideCart.prototype._render = function () {
    if (RESTORED) {
      RESTORED = false;
      this._armDecisionInflight = this._pairAwaiting = this._pairInflight = this._attachInflight = this._attachDedupeInflight = false;
    }
    kitCommitSelf = this;
    var out = origRender.apply(this, arguments);
    try {
      if (this._attachEl && this.cart && !this.cart.item_count) {
        this._attachEl.hidden = true;
        this._attachEl.innerHTML = '';
      }
      this._dedupeAttachAgainstBundles();
      this._applyPairFold();
      /* Drawer open only (audit P1-9): the tap has its own 1.5 s cold-cache
         wait, so a closed-drawer page load need not hit the workers. */
      if (this.isOpen && this.cart && this.cart.item_count) {
        var selfR = this;
        Promise.resolve(this._prefetchPairCandidate()).then(function (cand) { selfR._maybeShowOffer(cand); }).catch(function () {});
      } else if (this._pairOfferOpen) {
        this._hidePairOffer();
      }
      try {
        var ms = this._attachContext();
        this._lastMilestones = ms ? { ship: !!ms.shipUnlocked, gift: !!ms.giftUnlocked } : { ship: false, gift: false };
      } catch (e) {}
      this._recordArm();
    } catch (e) {}
    return out;
  };

  /* Kit built from the kit bar (not via the upsell card) with one of
     OUR attach lines still standalone: once a bundle lands carrying
     the same variant, drop the standalone. Only lines tagged
     `_hgn_src: sidecart_attach*` — a deliberately bought second top
     coat without the tag is left alone. One attempt per line key. */
  HGNSideCart.prototype._dedupeAttachAgainstBundles = function () {
    var self = this;
    if (!this.cart || this._attachDedupeInflight) return;
    var items = this.cart.items || [];
    var bundleVariants = {};
    items.forEach(function (it) { if (isBundleLine(it)) bundleVariants[String(it.variant_id)] = true; });
    if (!Object.keys(bundleVariants).length) return;
    if (!this._attachDeduped) this._attachDeduped = {};
    var updates = {}, n = 0;
    items.forEach(function (it) {
      if (isBundleLine(it) || isGiftLineItem(it)) return;
      if (attachSrc(it).indexOf('sidecart_attach') !== 0) return;
      if (!bundleVariants[String(it.variant_id)]) return;
      if (self._attachDeduped[it.key]) return;
      self._attachDeduped[it.key] = true;
      updates[it.key] = 0; n++;
    });
    if (!n) return;
    this._attachDedupeInflight = true;
    fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function () {
      if (window.console && console.info) console.info('[hgn-side-cart-attach] removed', n, 'attach line(s) now inside the kit');
      return self.refresh();
    }).catch(function () {}).then(function () { self._attachDedupeInflight = false; });
  };
  /* ─── Ready kit + a real line → commit the kit (Matt, 2026-09-09) ───
     Replication: build a kit to all-set (foot = "Checkout with my kit"
     £39.99), then add one more design from a PDP. The drawer flips to
     real-cart mode: the foot sums the real lines only ("Checkout" £7.99)
     and the kit is demoted to an in-list "Add my kit to basket" button —
     a foot tap leaves the kit behind. The kit-build file only finalises
     from that button, the empty-cart one-tap foot, or a retry (the
     automatic finalise on the last accessory pick was retired 2026-08-05
     to keep a review moment). A standalone add is a stronger signal than
     the last accessory pick — the shopper has finished reviewing and is
     shopping ON TOP of the kit — so the kit is committed through the
     kit-build's own seam (hgn:kit:finalise-request → its stock check →
     bundle lines → refresh) as soon as a real line lands. While it lands
     the foot reads "Adding your kit…" and taps are held via
     _kitCheckoutPending (the flag the one-tap path uses, so
     _syncCheckoutLabel and _handleCheckout already respect it).
     Fires only on an INCREASE in real (non-bundle, non-gift) quantity
     between two cart broadcasts — never on page load, a removal, a kit
     landing, or the stop-kit move (it clears the kit before its refresh).
     Decision is deferred 600 ms and re-checked: the build-mode toggle
     OFF moves picks to the cart BEFORE it writes 'off' (kit memory is
     kept), so the re-check sees mode off and stands down; a mode change
     in the last 5 s stands down too. One attempt per tier per landing. */
  var KIT_COMMIT_TIERS = ['classic', 'gels', 'press-ons'];
  var KIT_COMMIT_SETTLE_MS = 15000;
  var KIT_COMMIT_DEFER_MS = 600;
  var KIT_COMMIT_MODE_QUIET_MS = 5000;
  var kitCommitPrevReal = null;
  var kitCommitInflight = {};
  var kitCommitSelf = null;
  var kitCommitLastModeChange = 0;
  document.addEventListener('hgn:kit-build-mode:change', function () { kitCommitLastModeChange = Date.now(); });
  function realLineQty(cart) {
    var n = 0;
    ((cart && cart.items) || []).forEach(function (it) {
      if (isBundleLine(it) || isGiftLineItem(it)) return;
      n += (parseInt(it.quantity, 10) || 0);
    });
    return n;
  }
  function bundleTiersIn(cart) {
    var out = {};
    ((cart && cart.items) || []).forEach(function (it) {
      var bt = String(((it && it.properties) || {})._bundle_type || '');
      KIT_COMMIT_TIERS.forEach(function (t) { if (bt.indexOf(t + '-starter-kit') === 0) out[t] = true; });
    });
    return out;
  }
  function readyUnfinalisedTiers(cart) {
    var kp = window.HGN && window.HGN.kitProgress;
    var fs = window.HGN && window.HGN.kitFinaliseState;
    if (!kp || typeof fs !== 'function') return [];
    if (typeof kp.getKitBuildMode !== 'function' || kp.getKitBuildMode() !== 'on') return [];
    var inCart = bundleTiersIn(cart), out = [];
    KIT_COMMIT_TIERS.forEach(function (t) {
      if (inCart[t]) return;
      if (typeof kp.isTierEnabled === 'function' && !kp.isTierEnabled(t)) return;
      var st = null;
      try { st = fs(t); } catch (e) {}
      if (st && st.ready && st.unfilled === 0) out.push(t);
    });
    return out;
  }
  function kitCommitBusy() {
    for (var k in kitCommitInflight) if (kitCommitInflight[k]) return true;
    return false;
  }
  function commitReadyKit(tier) {
    var self = kitCommitSelf;
    var now = Date.now();
    if (kitCommitInflight[tier] && now - kitCommitInflight[tier] < KIT_COMMIT_SETTLE_MS) return;
    kitCommitInflight[tier] = now;
    if (window.console && console.info) console.info('[hgn-side-cart-attach] real line landed with an all-set ' + tier + ' kit: committing the kit');
    var settled = false;
    function settle() {
      if (settled) return;
      settled = true;
      kitCommitInflight[tier] = 0;
      document.removeEventListener('hgn:cart:change', onChange);
      if (self && !kitCommitBusy()) {
        self._kitCheckoutPending = false;
        if (self.checkoutBtn) self.checkoutBtn.disabled = false;
        try { if (typeof self._syncCheckoutLabel === 'function') self._syncCheckoutLabel(); } catch (e) {}
      }
    }
    function onChange(e) {
      var cart = e && e.detail && e.detail.cart;
      if (cart && bundleTiersIn(cart)[tier]) settle();
    }
    if (self) {
      self._kitCheckoutPending = true;
      if (self.checkoutBtn) self.checkoutBtn.disabled = true;
      if (self.checkoutLabelEl) self.checkoutLabelEl.textContent = 'Adding your kit…';
    }
    document.addEventListener('hgn:cart:change', onChange);
    try {
      document.dispatchEvent(new CustomEvent('hgn:kit:finalise-request', { detail: { tier: tier } }));
    } catch (e) { settle(); return; }
    setTimeout(settle, KIT_COMMIT_SETTLE_MS);
  }
  document.addEventListener('hgn:cart:change', function (e) {
    var cart = e && e.detail && e.detail.cart;
    if (!cart) return;
    var n = realLineQty(cart), prev = kitCommitPrevReal;
    kitCommitPrevReal = n;
    if (prev === null || n <= prev) return;
    if (!readyUnfinalisedTiers(cart).length) return;
    setTimeout(function () {
      if (Date.now() - kitCommitLastModeChange < KIT_COMMIT_MODE_QUIET_MS) return;
      var latest = (kitCommitSelf && kitCommitSelf.cart) || cart;
      if (realLineQty(latest) <= prev) return;
      readyUnfinalisedTiers(latest).forEach(commitReadyKit);
    }, KIT_COMMIT_DEFER_MS);
  });

  /* ═══════════ Kit-SKU line guard (+leakguard, 2026-09-14) ═══════════
     audit-harness/kit-products/LEAK-CLOSURE.md #4 / #8. A Starter Kit PRODUCT
     (the nine curated edits + the three blank-builder shells, type `Bundle`)
     is a gateway to the builder and NEVER a cart line (KIT-BUILD §11d "The one
     rule"): its line ships nothing, and BASKET-*, kit5, KITSHIP, Nail Points
     and HQ all assume a kit arrives as wrap + accessory lines carrying
     `_bundle_*` props. The PDP and the grid card have no add path, but an old
     /cart/add link, a bot or a re-order can still land one. On every cart
     broadcast any such line is removed in ONE /cart/update.js, the drawer
     refreshes, and the shopper is routed to that kit's prefill: a curated
     edit → HGN.curatedKits.apply(slug, 'cartguard') (prefill, collision modal
     if picks exist, drawer on the build section — `_hgn_src` then reads
     kitcurated:<tier>:cartguard); a shell, an unknown kit or a refusal → the
     kit's own product page, whose CTA builds it. Beacon
     `kitcurated_leak {path:'cart-line'}`. Real kit component lines carry
     `_bundle_type` / `_bundle_id` and are never touched. What never passes
     through a cart (a re-order permalink straight to checkout) is HQ's
     kits.leak_order flag. */
  var KIT_GUARD_QUIET_MS = 8000;
  var kitGuardAt = 0;
  function kitProductDefs() {
    var out = {};
    try {
      var ck = window.HGN && window.HGN.curatedKits;
      var defs = ck && typeof ck.definitions === 'function' ? ck.definitions() : (window.HGN_CURATED_KITS || []);
      (defs || []).forEach(function (k) { if (k && k.handle) out[lc(k.handle)] = k; });
    } catch (e) {}
    return out;
  }
  function isKitProductLine(it, known) {
    if (!it) return false;
    /* Never a gift card, never a subscription (Nail Drop's dummy SKU carries a
       selling plan), never a line stamped by a bundle system — HGN kit
       components (`_bundle_type` / `_bundle_id` / `_bundle_price_*`), Nail Drop
       groups (`_bundle_type: 'nail-drop'`) and Easy Bundles legacy lines all
       carry a `_bundle…` property. `/cart.js` fields read here: `handle`,
       `product_type`, `product_title`, `properties` (null when none). */
    if (it.gift_card === true || it.selling_plan_allocation) return false;
    var props = it.properties || {};
    for (var pk in props) { if (Object.prototype.hasOwnProperty.call(props, pk) && pk.indexOf('_bundle') === 0) return false; }
    var handle = lc(it.handle);
    if (handle && known[handle]) return true;
    var title = lc(it.product_title || it.title);
    return lc(it.product_type).trim() === 'bundle' && (/starter-kit$/.test(handle) || title.indexOf('starter kit') !== -1);
  }
  /* Checkout-click is a one-way door: the mint (`_proceedToCheckout` →
     BASKET-* / Nail Points / ad-hoc) must never race a /cart/update.js from
     here. `kitCommitSelf` is the drawer instance captured by the _render
     wrapper; before the first render there is nothing in flight. */
  function kitGuardBusy() {
    var inst = kitCommitSelf;
    try { return !!(inst && (inst._checkoutInflight || inst._mintInflight || inst._kitCheckoutPending)); } catch (e) { return false; }
  }
  function kitGuardProductPage(line, kit) {
    var url = (kit && kit.productUrl) || (line && line.url ? String(line.url).split('?')[0] : '') ||
      ('/products/' + encodeURIComponent((line && line.handle) || ''));
    try { if (location.pathname === url) return; } catch (e) {}
    location.href = url;
  }
  function kitGuardRoute(line, kit) {
    var ck = window.HGN && window.HGN.curatedKits;
    if (!kit || kit.shell || !ck || typeof ck.apply !== 'function') { kitGuardProductPage(line, kit); return; }
    ck.apply(kit.slug, 'cartguard').then(function (r) {
      if (r && (r.ok || r.reason === 'cancelled')) return;
      kitGuardProductPage(line, kit);
    }).catch(function () { kitGuardProductPage(line, kit); });
  }
  document.addEventListener('hgn:cart:change', function (e) {
    var items = (e && e.detail && e.detail.cart && e.detail.cart.items) || [];
    if (!items.length) return;
    var known = kitProductDefs();
    var hits = items.filter(function (it) { return isKitProductLine(it, known); });
    if (!hits.length) return;
    if (kitGuardBusy()) return; /* never during the checkout-click mint */
    /* our own removal re-broadcasts the cart; one pass per burst */
    if (Date.now() - kitGuardAt < KIT_GUARD_QUIET_MS) return;
    kitGuardAt = Date.now();
    var updates = {};
    hits.forEach(function (it) { updates[it.key] = 0; });
    var first = hits[0];
    var kit = known[lc(first.handle)] || null;
    offerEvent('kitcurated_leak', {
      path: 'cart-line', reason: 'cart-line', handle: first.handle, slug: kit ? kit.slug : '',
      lines: hits.length, qty: hits.reduce(function (n, it) { return n + (parseInt(it.quantity, 10) || 0); }, 0)
    });
    fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) { return r.ok ? r.json() : null; }).then(function (cart) {
      if (!cart) return;
      try { if (window.HGN && window.HGN.sideCart && typeof window.HGN.sideCart.refresh === 'function') window.HGN.sideCart.refresh(); } catch (err) {}
      kitGuardRoute(first, kit);
    }).catch(function () {});
  });
  /* Debug + probe handle (pure predicate, no side effects). */
  try { window.HGN = window.HGN || {}; window.HGN.kitLineGuard = { isKitProductLine: function (it) { return isKitProductLine(it, kitProductDefs()); } }; } catch (e) {}

  /* ═══════════ Kit nudge — arm family 2 (2026-09-11) ═══════════
     Design: hq-v1/KIT-NUDGE-EXPERIMENT-DESIGN-2026-09-11.md §B.7–B.9 (the
     profitability gate) and §C.1–C.2 (the experiment contract).
     Audit:  audit-harness/KIT-NUDGE-AUDIT-2026-09-11.md §4 (P0-1/2/3).

     Arm A = today's drawer, byte-identical. Arm B, and ONLY arm B:

       C1  the kit card carries the builder's own money block — kit price,
           "worth £X separately", "save Y%" (percentage first, absolute in
           smaller type — KIT-BUNDLING-RESEARCH §9.1/§10.5), the contents
           line and "free UK shipping included". The dead `savingCents`
           branch in the main file (audit P0-1) is bypassed, not patched:
           the numbers come from HGN.computeProjectedKitMath, the same
           helper the kit-lead PDP badge uses, so they cannot drift.
       C2  the flat `upsell_aov_gate_gbp = 30` suppression is replaced by
           the contribution gate below. The legacy gate is untouched and
           still governs arm A.
       C3  the kit card leads: it moves above the cart lines (so it clears
           the sticky foot on an iPhone 13 — audit P0-3) and the attach row
           is forced beneath it. The Checkout CTA is never touched.

     Stamping: `_hgn_src = kitnudge:<tier>:sidecart` on every bundle line
     of a kit built from this card, injected into the finalise POST by the
     fetch shim at the end of this block (the kit-build snippet owns
     bundleProps and is not edited). Underscore-prefixed, so it stays
     invisible after the BASKET-* fold (offers audit 2026-09-09).

     One-sided by construction: the gate compares the CONTRIBUTION of the
     basket in hand against the contribution of the kit it would become,
     and refuses the swap unless the kit wins by `marginGbp`. A £51.95
     accessory-heavy basket and a 3-wraps-plus-top-coat basket are both
     refused; 1–3 classic designs, 1–2 gels and 1–2 press-ons are not. */

  var KITNUDGE_SRC_KEY = 'hgn_kitnudge_src';
  var KITNUDGE_SRC_TTL_MS = 45 * 60 * 1000;
  /* Verdicts the gate is NOT entitled to act on. Arm B must be arm A on
     these baskets, never a surface removal (review 2026-09-11 P0-1/P1-2):

       non-gbp     the gate's whole rate card is UK. Every CHF/EUR/USD/SEK
                   cart exits here, and the legacy card has no currency
                   gate at all — so wiping it would delete a live upsell
                   from every non-UK market, invisibly to a GB-forced probe.
       error       a thrown gate cannot have an opinion.
       no-cart     nothing to judge.
       has-kit     fires on ANY bundled line; the main file is finer —
                   it skips only the tiers already bundled, so a classic
                   kit + 3 gel designs still pitches the GEL kit.
       mixed-tier  the gate has no single kit to swap into; the main file
                   picks the dominant tier and pitches that.

     Everything else — contribution-negative, marginal,
     already-kit-sized, tier-off, no-designs, no-kit-price — keeps the
     suppress-the-card behaviour, because THAT is the experiment. */
  var KITNUDGE_OUT_OF_SCOPE = {
    'non-gbp': 1, 'error': 1, 'no-cart': 1, 'has-kit': 1, 'mixed-tier': 1
  };
  var KITNUDGE_TIER_LABEL = {
    classic:     'Classic Starter Kit',
    gels:        'Gel Starter Kit',
    'press-ons': 'Press-On Starter Kit'
  };
  var KITNUDGE_DESIGN_NOUN = {
    classic:     { one: 'design',       many: 'designs' },
    gels:        { one: 'gel wrap',     many: 'gel wraps' },
    'press-ons': { one: 'press-on set', many: 'press-on sets' }
  };
  var KITNUDGE_INCLUDES = {
    classic:     ['top coat', 'gift bag'],
    gels:        ['LED lamp', 'gift bag'],
    'press-ons': ['press-on remover', 'gift bag']
  };
  /* The accessory COGS keys a full kit of each tier carries. Kit COGS is
     derived (minimum × design COGS + these), never a frozen total, so a
     rate-card edit in the announcement bar flows through. */
  var KITNUDGE_KIT_ACC = {
    classic:     ['topcoat', 'giftbag'],
    gels:        ['lamp', 'giftbag'],
    'press-ons': ['pressonremover', 'giftbag']
  };

  /* Baked defaults — HQ's rate card as at 2026-09-11 (design doc §B.1/§B.2).
     Every one of them is an OPTIONAL announcement-bar override; nothing
     here is a prerequisite for the snippet to work. */
  var KITNUDGE_DEFAULTS = {
    enabled:        true,
    marginGbp:      3.00,
    optionValueGbp: 0.00,
    allowMarginal:  false,
    econ: {
      vatFraction:      1 / 6,
      feePct:           0.019,
      feeFixed:         0.25,
      fulBase:          3.26,
      fulPick:          1.00,
      fulPerItem:       0.38,
      postageGbp:       2.99,
      shipThresholdGbp: 39.99,
      defaultCogsRate:  0.18
    },
    cogs: {
      classic:        0.48,
      gels:           2.60,
      'press-ons':    2.40,
      topcoat:        2.40,
      lamp:           2.50,
      giftbag:        1.75,
      pressonremover: 2.10,
      magicremover:   2.50,
      tabs:           2.10,
      glue:           0.60,
      nailfile:       1.50
    }
  };
  /* `kit_nudge_econ` textarea → { key: number }. Same tolerant free-text
     shape as the pair offer's per-currency table, so a rate change is one
     paste and a typo is ignored rather than fatal. */
  function parseEconTable(raw) {
    var out = {};
    String(raw == null ? '' : raw).split(/[\n;,]+/).forEach(function (line) {
      var m = String(line).trim().match(/^([A-Za-z][\w-]*)\s*[:=\s]\s*(-?\d+(?:\.\d+)?)$/);
      if (m) out[m[1].toLowerCase()] = parseFloat(m[2]);
    });
    return out;
  }
  function numOr(v, fallback) {
    var n = parseFloat(v);
    return isFinite(n) ? n : fallback;
  }
  function kitNudgeCfg(self) {
    var raw = ((self && self.config && self.config.attach) || {}).kitNudge || {};
    var econ = {}, cogs = {};
    Object.keys(KITNUDGE_DEFAULTS.econ).forEach(function (k) { econ[k] = KITNUDGE_DEFAULTS.econ[k]; });
    Object.keys(KITNUDGE_DEFAULTS.cogs).forEach(function (k) { cogs[k] = KITNUDGE_DEFAULTS.cogs[k]; });
    var table = parseEconTable(raw.econTable);
    Object.keys(table).forEach(function (k) {
      if (econ[k] != null) econ[k] = table[k];
      else cogs[k] = table[k];
    });
    /* Shipping threshold is the side cart's own SSoT unless overridden. */
    try {
      var ship = (self && self.config && self.config.shipping) || {};
      if (ship.gbp != null && table.shipthresholdgbp == null) econ.shipThresholdGbp = numOr(ship.gbp, econ.shipThresholdGbp);
    } catch (e) {}
    return {
      enabled:        raw.enabled !== false,
      marginGbp:      numOr(raw.marginGbp, KITNUDGE_DEFAULTS.marginGbp),
      optionValueGbp: numOr(raw.optionValueGbp, KITNUDGE_DEFAULTS.optionValueGbp),
      allowMarginal:  raw.allowMarginal === true,
      /* `raw.maxDiscountPct` (announcement bar "Suppress above this
         order-code discount") is deliberately NOT read any more — see the
         discount-state note inside kitNudgeGate (2026-09-13). */
      econ:           econ,
      cogs:           cogs
    };
  }

  /* ─── COGS lookup for a cart line ───
     Design lines cost by tier; the accessories HGN actually sells are
     matched on handle/title; anything unrecognised falls back to a share
     of its own retail so an unknown SKU can never make a basket look
     free to fulfil (which would over-fire the nudge). */
  function kitNudgeCogsKey(it) {
    var h = itemHandle(it), t = itemTitle(it);
    function has(s) { return h.indexOf(s) !== -1 || t.indexOf(s.replace(/-/g, ' ')) !== -1; }
    if (has('top-coat')) return 'topcoat';
    if (h.indexOf('led-lamp') !== -1 || (lc(it && it.product_type).indexOf('accessor') !== -1 && t.indexOf('lamp') !== -1)) return 'lamp';
    if (has('press-on-nail-remover')) return 'pressonremover';
    if (has('magic-remover')) return 'magicremover';
    if (has('adhesive') || t.indexOf('tabs') !== -1) return 'tabs';
    if (has('glue')) return 'glue';
    if (has('nail-file') || t.indexOf('nail file') !== -1) return 'nailfile';
    if (t.indexOf('bag') !== -1 || h.indexOf('make-up-bag') !== -1) return 'giftbag';
    return null;
  }
  function kitNudgeLineCogs(it, cfg) {
    var qty = parseInt(it && it.quantity, 10) || 0;
    if (!qty) return 0;
    var tier = classifyTier(it && it.product_type);
    if (tier && cfg.cogs[tier] != null) return cfg.cogs[tier] * qty;
    var key = kitNudgeCogsKey(it);
    if (key && cfg.cogs[key] != null) return cfg.cogs[key] * qty;
    var unit = numOr(it && it.price, 0) / 100;
    return unit * cfg.econ.defaultCogsRate * qty;
  }

  /* Per-order contribution, exactly the walk `orderContribCte()` uses in
     hq-v1/worker/src/lib/econ.js:
       net − COGS − VAT − (net×feePct + feeFixed) − (base + pick + extras)
     `net` is what the shopper pays INCLUDING any postage they are charged;
     VAT and the gateway fee are levied on that same figure. */
  function kitNudgeContribution(netGbp, items, cogsGbp, econ) {
    var n = Math.max(0, numOr(netGbp, 0));
    var q = Math.max(1, parseInt(items, 10) || 1);
    var vat = n * econ.vatFraction;
    var fee = n * econ.feePct + econ.feeFixed;
    var ful = econ.fulBase + econ.fulPick + Math.max(0, q - 1) * econ.fulPerItem;
    return n - numOr(cogsGbp, 0) - vat - fee - ful;
  }

  function kitNudgeRound(n) { return Math.round(n * 100) / 100; }

  /* ═══ The gate, as a pure function (design doc §B.9) ═══
     kitNudgeGate(cart, opts) → { allowed, tier, deltaGbp, reason,
                                  codeConflict, … }
     Never throws, never returns undefined. `deltaGbp` is filled in
     whenever a tier could be resolved, even on a blocked verdict — a
     blocked nudge with its delta is the most useful telemetry the surface
     can produce.

     opts.cfg        the merged config from kitNudgeCfg()
     opts.prices     GBP kit prices    (default window.HGN_KIT_BUNDLE_PRICES)
     opts.minimums   designs per kit   (default window.HGN.STARTER_KIT_MINIMUMS)
     opts.enabled    per-tier switches (default window.HGN_KIT_ENABLED)
     opts.isTierEnabled  per-market kill switch (default HGN.kitProgress) */
  function kitNudgeGate(cart, opts) {
    var res = {
      allowed: false, tier: null, deltaGbp: 0, reason: 'no-cart',
      marginal: false, designCount: 0, minimum: 0,
      kitGbp: 0, kitContribGbp: 0, basketContribGbp: 0, discountPct: 0,
      codeConflict: false
    };
    try {
      opts = opts || {};
      var cfg = opts.cfg || kitNudgeCfg(null);
      var econ = cfg.econ, cogsMap = cfg.cogs;
      if (!cart || !cart.items) return res;

      /* 1 — market. Every number in §B is UK; non-GBP kits have their own
             fixed stickers and their own fulfilment rate card. */
      if (String(cart.currency || 'GBP').toUpperCase() !== 'GBP') { res.reason = 'non-gbp'; return res; }

      var items = cart.items || [];
      var prices    = opts.prices   || (typeof window !== 'undefined' && window.HGN_KIT_BUNDLE_PRICES) || {};
      var minimums  = opts.minimums || (typeof window !== 'undefined' && window.HGN && window.HGN.STARTER_KIT_MINIMUMS) ||
                      { classic: 5, gels: 3, 'press-ons': 3 };
      var enabled   = opts.enabled  || (typeof window !== 'undefined' && window.HGN_KIT_ENABLED) || {};

      /* 2 — a kit is already in the basket. */
      var hasKit = false;
      items.forEach(function (it) {
        var bt = String(((it && it.properties) || {})._bundle_type || '');
        if (/-starter-kit$/.test(bt) || /-starter-kit/.test(bt)) hasKit = true;
      });
      if (hasKit) { res.reason = 'has-kit'; return res; }

      /* 3 — tier resolve. Accessories are ignored; two design tiers in one
             basket have no single kit to swap into. */
      var units = {}, tiers = [];
      items.forEach(function (it) {
        if (isGiftLineItem(it)) return;
        var t = classifyTier(it && it.product_type);
        if (!t || t === 'accessories') return;
        var title = lc((it && (it.title || it.product_title)) || '');
        if (title.indexOf('pack') !== -1 || title.indexOf('matching tips') !== -1) return;
        if (!units[t]) { units[t] = 0; tiers.push(t); }
        units[t] += (parseInt(it.quantity, 10) || 0);
      });
      if (!tiers.length) { res.reason = 'no-designs'; return res; }
      if (tiers.length > 1) { res.reason = 'mixed-tier'; return res; }
      var tier = tiers[0];
      res.tier = tier;
      res.designCount = units[tier];
      res.minimum = parseInt(minimums[tier], 10) || 0;

      /* 4 — tier enabled: the announcement-bar SSoT plus the per-market
             kill switch. Never re-derived here. */
      if (enabled[tier] === false) { res.reason = 'tier-off'; return res; }
      var tierEnabledFn = opts.isTierEnabled;
      if (tierEnabledFn == null) {
        try {
          var kp = (typeof window !== 'undefined') && window.HGN && window.HGN.kitProgress;
          if (kp && typeof kp.isTierEnabled === 'function') tierEnabledFn = function (t) { return kp.isTierEnabled(t); };
        } catch (e) {}
      }
      if (typeof tierEnabledFn === 'function') {
        var ok = true;
        try { ok = tierEnabledFn(tier) !== false; } catch (e) {}
        if (!ok) { res.reason = 'tier-off'; return res; }
      }

      /* 6 (computed early so the delta is available on every verdict) —
             discount state. Matt's rule (2026-09-13): order-class codes are
             NEVER applied to a Starter Kit — kits are already heavily
             discounted. SIDE-CART.md §16.3: kit-only cart + order code is
             refused at apply; on a mixed cart the code touches only the
             non-kit lines. So the code discounts the BASKET side only and
             the kit side stays at its sticker. Nail Points likewise never
             reaches the kit side: NAILPOINTS-* and BASKET-* are mutually
             exclusive at checkout (§10 — under NP intent the kit lines
             revert to retail), so a nudged kit is priced without it. Both
             reductions therefore apply to the basket side alone. */
      var attrs = (cart && cart.attributes) || {};
      var pct = 0, nailPointsGbp = 0;
      if (attrs._hgn_discount_intent === 'adhoc' &&
          attrs._hgn_adhoc_class === 'order' &&
          attrs._hgn_adhoc_value_type === 'percentage') {
        pct = numOr(attrs._hgn_adhoc_value, 0);
        if (pct > 1) pct = pct / 100;
        if (!(pct > 0)) pct = 0;
        if (pct > 0.95) pct = 0.95;
      }
      if (attrs._hgn_discount_intent === 'nailpoints') nailPointsGbp = Math.max(0, numOr(attrs._hgn_nailpoints_amount_gbp, 0));
      res.discountPct = pct;

      /* 7 — contribution, both sides. Only the basket side is discounted. */
      var basketNet = 0, basketCogs = 0;
      items.forEach(function (it) {
        var line = numOr(it && it.final_line_price, numOr(it && it.line_price, 0)) / 100;
        basketNet += line;
        basketCogs += kitNudgeLineCogs(it, cfg);
      });
      basketNet = Math.max(0, basketNet * (1 - pct) - nailPointsGbp);
      var basketItems = parseInt(cart.item_count, 10) || items.length || 1;
      var basketGross = basketNet + (basketNet < econ.shipThresholdGbp ? econ.postageGbp : 0);
      var basketContrib = kitNudgeContribution(basketGross, basketItems, basketCogs, econ);

      var kitGbp = numOr(prices[tier], 0);
      if (!(kitGbp > 0)) { res.reason = 'no-kit-price'; return res; }
      res.kitGbp = kitGbp;
      var accKeys = KITNUDGE_KIT_ACC[tier] || [];
      var kitItems = (res.minimum || 0) + accKeys.length;
      var kitCogs = (res.minimum || 0) * numOr(cogsMap[tier], 0);
      accKeys.forEach(function (k) { kitCogs += numOr(cogsMap[k], 0); });
      /* Free UK shipping on every Starter Kit is a standing promise (the
         drawer's own kit copy states it), so the kit side never carries
         postage. No code and no Nail Points on this side either (step 6):
         the kit is priced at its sticker, full stop. */
      var kitNet = kitGbp;
      var kitContrib = kitNudgeContribution(kitNet, kitItems, kitCogs, econ);

      res.basketContribGbp = kitNudgeRound(basketContrib);
      res.kitContribGbp = kitNudgeRound(kitContrib);
      res.deltaGbp = kitNudgeRound(kitContrib - basketContrib + numOr(cfg.optionValueGbp, 0));

      /* 5 — design-count ceiling. A shopper at or above the minimum wants
             kit PRICING, not a swap nudge — and the swap is loss-making
             there anyway. Checked after the arithmetic so the delta is
             still reported. */
      if (res.minimum && res.designCount >= res.minimum) { res.reason = 'already-kit-sized'; return res; }

      /* (There is no deep-code stop any more, 2026-09-13. It existed only
          because the old maths discounted the kit too; with the kit at its
          sticker a code makes the kit MORE attractive, not less.) */

      /* 8 — verdict. `codeConflict` rides an allowed verdict under a code so
             the money block can say, honestly, that the code will not apply
             to the kit. */
      if (res.deltaGbp >= numOr(cfg.marginGbp, 3)) {
        res.allowed = true;
        res.reason = 'nudge';
        res.codeConflict = pct > 0;
        return res;
      }
      if (res.deltaGbp > 0) {
        res.marginal = true;
        res.reason = 'marginal';
        res.allowed = cfg.allowMarginal === true;
        res.codeConflict = res.allowed && pct > 0;
        return res;
      }
      res.reason = 'contribution-negative';
      return res;
    } catch (e) {
      res.reason = 'error';
      return res;
    }
  }
  try {
    window.HGN = window.HGN || {};
    window.HGN.kitNudgeGate = kitNudgeGate;
    window.HGN.kitNudgeConfig = kitNudgeCfg;
  } catch (e) {}

  registerArm('kitnudge', 'kitNudgeArm');

  /* ─── the money block ─── */
  function kitNudgeMath(tier) {
    var m = null;
    try {
      if (window.HGN && typeof window.HGN.computeProjectedKitMath === 'function') m = window.HGN.computeProjectedKitMath(tier, null);
    } catch (e) {}
    var price = numOr(m && m.kitPrice, numOr((window.HGN_KIT_BUNDLE_PRICES || {})[tier], 0));
    var retail = numOr(m && m.retail, 0);
    if (!(retail > price)) {
      /* Pre-math fallback: the canonical retail table, same basis the
         builder uses before its IIFE has installed computeProjectedKitMath. */
      var rt = (window.HGN_KIT_RETAILS || {})[tier] || {};
      var mins = (window.HGN && window.HGN.STARTER_KIT_MINIMUMS) || { classic: 5, gels: 3, 'press-ons': 3 };
      var min = parseInt(mins[tier], 10) || 0;
      retail = min * numOr(rt.design, 0);
      (KITNUDGE_KIT_ACC[tier] || []).forEach(function (k) {
        var slot = k === 'topcoat' ? 'topCoat' : k === 'lamp' ? 'uvLamp' : k === 'pressonremover' ? 'remover' : 'giftBag';
        retail += numOr(rt[slot], 0);
      });
    }
    var savings = Math.max(0, retail - price);
    var pct = retail > 0 ? Math.round((savings / retail) * 100) : 0;
    return { price: price, retail: retail, savings: savings, pct: pct, ok: price > 0 && retail > price };
  }

  function kitNudgeCountLine(gate) {
    var noun = KITNUDGE_DESIGN_NOUN[gate.tier] || KITNUDGE_DESIGN_NOUN.classic;
    var need = Math.max(1, (gate.minimum || 0) - (gate.designCount || 0));
    /* Never open the counter at zero (KIT-BUNDLING-RESEARCH §9.1, endowed
       progress) — the card only fires with at least one design in the bag,
       so the inherited count is always the shopper's own. */
    return gate.designCount + ' of ' + gate.minimum + ' chosen — pick ' +
           need + ' more ' + (need === 1 ? noun.one : noun.many);
  }

  function kitNudgeMoneyHtml(self, gate, math) {
    var cur = (self.cart && self.cart.currency) || 'GBP';
    var c = function (gbp) { return formatMoney(Math.round(gbp * 100), cur); };
    var noun = (KITNUDGE_DESIGN_NOUN[gate.tier] || KITNUDGE_DESIGN_NOUN.classic).many;
    var inc = (KITNUDGE_INCLUDES[gate.tier] || []).join(' + ');
    return '' +
      '<span class="hgn-side-cart__kitnudge-count">' + escapeHtml(kitNudgeCountLine(gate)) + '</span>' +
      '<span class="hgn-side-cart__kitnudge-money">' +
        '<span class="hgn-side-cart__kitnudge-pct">Save ' + math.pct + '%</span>' +
        '<span class="hgn-side-cart__kitnudge-abs">' + c(math.savings) + ' off</span>' +
      '</span>' +
      '<span class="hgn-side-cart__kitnudge-price">' +
        '<strong>' + c(math.price) + '</strong>' +
        /* PDP parity (audit P0-4): the à-la-carte total is LABELLED TEXT,
           never a strike-through, and it uses the PDP's exact wording. */
        '<span class="hgn-side-cart__kitnudge-worth"><span class="hgn-side-cart__kitnudge-worth-fig">' +
          c(math.retail) + '</span> if bought separately</span>' +
      '</span>' +
      '<span class="hgn-side-cart__kitnudge-inc">' +
        gate.minimum + ' ' + escapeHtml(noun) + (inc ? ' + ' + escapeHtml(inc) : '') +
      '</span>' +
      '<span class="hgn-side-cart__kitnudge-ship">Free UK shipping included</span>' +
      /* Under an order-class code the code will not reach the kit (Matt's
         rule, 2026-09-13; SIDE-CART.md §16.3). One honest line, no "free". */
      (gate.codeConflict
        ? '<span class="hgn-side-cart__kitnudge-code">Your code won\'t apply to a kit — but the kit already saves you ' + math.pct + '%</span>'
        : '');
  }
  /* Exported so audit-harness/kit-nudge-gate.test.js can assert the
     no-strike-through rule against the REAL builder, never a copy of it. */
  try { window.HGN = window.HGN || {}; window.HGN.kitNudgeMoneyHtml = kitNudgeMoneyHtml; } catch (e) {}

  /* ─── ordering (C3) ───
     Kit-first means the card sits ABOVE the cart lines, where it clears
     the sticky foot on a stock iPhone 13 (audit P0-3: the card at
     421–565px sat behind a foot that begins at ~370px). Idempotent DOM
     moves only; nothing about the foot or the Checkout CTA is touched. */
  function kitNudgePlace(self, first) {
    try {
      var host = self.upsellEl;
      if (!host || !host.parentNode) return;
      var anchor = (self.body || document).querySelector('[data-hgn-side-cart-cart-section]');
      if (!anchor || anchor.parentNode !== host.parentNode) return;
      var attach = self._attachEl;
      if (attach && attach.parentNode !== host.parentNode) attach = null;
      if (first) {
        /* kit card → attach row → cart lines. Placing BOTH here is what
           keeps the two rules from fighting: _placeAttach anchors the
           attach row to the kit card, and this anchors the kit card to
           the cart section, so each render would otherwise undo the
           other and the attach row would drift back on top. */
        if (attach) {
          if (attach.nextSibling !== anchor) anchor.parentNode.insertBefore(attach, anchor);
          if (host.nextSibling !== attach) attach.parentNode.insertBefore(host, attach);
        } else if (host.nextSibling !== anchor) {
          anchor.parentNode.insertBefore(host, anchor);
        }
      } else {
        if (host.previousSibling !== anchor) anchor.parentNode.insertBefore(host, anchor.nextSibling);
      }
      host.classList.toggle('hgn-side-cart__upsell--kitnudge-first', !!first);
    } catch (e) {}
  }

  /* Telemetry: one eligible/blocked tag per cart token + reason, so a
     drawer that re-renders six times does not emit six events. */
  var kitNudgeLastEvent = '';
  function kitNudgeTelemetry(self, gate) {
    try {
      var sig = ((self.cart && self.cart.token) || '') + '|' + gate.reason + '|' + (gate.tier || '');
      if (sig === kitNudgeLastEvent) return;
      kitNudgeLastEvent = sig;
      if (gate.allowed) offerEvent('kitnudge_eligible', { kind: gate.tier });
      else if (gate.tier) offerEvent('kitnudge_blocked', { kind: gate.reason });
    } catch (e) {}
  }

  function armKitNudgeSrc(tier) {
    try { sessionStorage.setItem(KITNUDGE_SRC_KEY, JSON.stringify({ tier: tier, at: Date.now() })); } catch (e) {}
  }
  function readKitNudgeSrc() {
    try {
      var raw = sessionStorage.getItem(KITNUDGE_SRC_KEY);
      if (!raw) return null;
      var v = JSON.parse(raw);
      if (!v || !v.tier || (Date.now() - (v.at || 0)) > KITNUDGE_SRC_TTL_MS) return null;
      return v;
    } catch (e) { return null; }
  }
  function clearKitNudgeSrc() {
    try { sessionStorage.removeItem(KITNUDGE_SRC_KEY); } catch (e) {}
  }

  /* ─── the surface ───
     Surgical, not a rewrite: the original card's dismiss button and CTA
     (and their listeners, and the `match` closure they hold) stay exactly
     where the main file put them. Only the sub-copy paragraph's contents
     and the CTA label change. */
  HGNSideCart.prototype._applyKitNudge = function (gate) {
    var host = this.upsellEl;
    if (!host) return;
    if (!gate || !gate.allowed) {
      this._kitNudgeActive = false;
      if (host.classList) host.classList.remove('hgn-side-cart__upsell--kitnudge');
      host.removeAttribute('data-hgn-kitnudge-tier');
      if (!host.hidden || host.innerHTML) { host.hidden = true; host.innerHTML = ''; }
      kitNudgePlace(this, false);
      return;
    }
    /* Nothing to dress — the card was suppressed upstream (the 5-minute
       dismiss snooze, an active kit build, a Nail Drop queue). Stand the
       ordering down too so _placeAttach resumes owning the attach row. */
    if (host.hidden || !host.innerHTML) { this._kitNudgeActive = false; kitNudgePlace(this, false); return; }
    var cta = host.querySelector('[data-hgn-side-cart-upsell-cta]');
    var shownTier = cta && cta.getAttribute('data-hgn-upsell-tier');
    /* The card and the gate must agree on the tier. They can only diverge
       on a basket the gate would have called mixed-tier, so treat a
       mismatch as a block rather than repricing the wrong kit. */
    if (!shownTier || shownTier !== gate.tier) {
      host.hidden = true; host.innerHTML = '';
      this._kitNudgeActive = false;
      kitNudgePlace(this, false);
      return;
    }
    var math = kitNudgeMath(gate.tier);
    if (!math.ok) { this._kitNudgeActive = false; kitNudgePlace(this, false); return; }

    var title = host.querySelector('.hgn-side-cart__upsell-title');
    if (title) {
      title.innerHTML = 'Turn these into a <strong>' +
        escapeHtml(KITNUDGE_TIER_LABEL[gate.tier] || 'Starter Kit') + '</strong>';
    }
    var sub = host.querySelector('.hgn-side-cart__upsell-sub');
    if (sub) sub.innerHTML = kitNudgeMoneyHtml(this, gate, math);
    var dead = host.querySelector('.hgn-side-cart__upsell-saving');
    if (dead && dead.parentNode) dead.parentNode.removeChild(dead);
    if (cta) {
      cta.textContent = 'Build my kit · ' +
        formatMoney(Math.round(math.price * 100), (this.cart && this.cart.currency) || 'GBP');
    }
    host.classList.add('hgn-side-cart__upsell--kitnudge');
    host.setAttribute('data-hgn-kitnudge-tier', gate.tier);
    kitNudgePlace(this, true);

    /* Declined: the dismiss button is re-created on every render, so the
       listener lives on the stable host element instead. */
    if (!host.__hgnKitNudgeWired) {
      host.__hgnKitNudgeWired = true;
      var selfW = this;
      host.addEventListener('click', function (e) {
        try {
          var t = e.target && e.target.closest && e.target.closest('[data-hgn-side-cart-upsell-dismiss]');
          if (!t) return;
          var g = selfW._kitNudgeGate;
          if (g && g.allowed) offerEvent('kitnudge_declined', { kind: g.tier });
        } catch (err) {}
      }, true);
    }
    if (this._kitNudgeShown !== gate.tier + '|' + ((this.cart && this.cart.token) || '')) {
      this._kitNudgeShown = gate.tier + '|' + ((this.cart && this.cart.token) || '');
      offerEvent('kitnudge_shown', { kind: gate.tier });
    }
  };

  /* Attach-row ordering: while the nudge is up, kitNudgePlace() owns the
     order of both rows (see above), so the IR-1 "one design line → attach
     first" rule stands down rather than fighting it. Arm A and every
     blocked basket keep the original rule untouched. */
  var origPlaceAttachKN = HGNSideCart.prototype._placeAttach;
  HGNSideCart.prototype._placeAttach = function (first) {
    if (this._kitNudgeActive) return;
    return origPlaceAttachKN.apply(this, arguments);
  };

  var origRenderUpsellKN = HGNSideCart.prototype._renderUpsell;
  HGNSideCart.prototype._renderUpsell = function (groups) {
    var cfg = kitNudgeCfg(this);
    var arm = armFor(this, 'kitnudge');
    if (arm !== 'B' || cfg.enabled === false) {
      this._kitNudgeActive = false;
      this._kitNudgeGate = null;
      /* If the merchant flipped the arm (or the kill switch) mid-session, put
         the card back where arm A expects it rather than leaving it stranded
         above the cart lines. */
      try {
        var h = this.upsellEl;
        if (h && h.classList && h.classList.contains('hgn-side-cart__upsell--kitnudge-first')) {
          h.classList.remove('hgn-side-cart__upsell--kitnudge');
          h.removeAttribute('data-hgn-kitnudge-tier');
          kitNudgePlace(this, false);
        }
      } catch (e) {}
      return origRenderUpsellKN.apply(this, arguments);
    }
    var gate = kitNudgeGate(this.cart, { cfg: cfg });
    this._kitNudgeGate = gate;
    this._kitNudgeActive = !!gate.allowed;
    kitNudgeTelemetry(this, gate);
    /* Out of the gate's scope (review P0-1 / P1-2): it cannot judge this
       basket, so arm B renders arm A's card untouched. Stand the ordering
       down first so _placeAttach resumes owning the attach row, exactly as
       the arm-A / kill-switch path above does. */
    if (!gate.allowed && KITNUDGE_OUT_OF_SCOPE[gate.reason]) {
      this._kitNudgeActive = false;
      try {
        var hOOS = this.upsellEl;
        if (hOOS && hOOS.classList && hOOS.classList.contains('hgn-side-cart__upsell--kitnudge-first')) {
          hOOS.classList.remove('hgn-side-cart__upsell--kitnudge');
          hOOS.removeAttribute('data-hgn-kitnudge-tier');
          kitNudgePlace(this, false);
        }
      } catch (e) {}
      return origRenderUpsellKN.apply(this, arguments);
    }
    var up = (this.config && this.config.upsell) || null;
    var prevGate = up ? up.aovGateGbp : null;
    /* Arm B replaces the flat AOV proxy with the contribution gate, so the
       legacy gate is neutralised for the duration of THIS render only —
       `this.config.upsell.aovGateGbp` is restored before we return, and
       arm A never sees it move. */
    if (up && gate.allowed) up.aovGateGbp = 1e6;
    var out;
    try { out = origRenderUpsellKN.apply(this, arguments); }
    finally { if (up) up.aovGateGbp = prevGate; }
    try { this._applyKitNudge(gate); } catch (e) {
      if (window.console && console.warn) console.warn('[hgn-kit-nudge]', e);
    }
    return out;
  };

  /* Accepted: arm the source memo as the shopper enters the build. The
     card's own CTA is the only caller that matters, but wrapping the
     handler covers the send-to-kit path too. */
  var origUpsellClickKN = HGNSideCart.prototype._handleUpsellClick;
  HGNSideCart.prototype._handleUpsellClick = function (match) {
    try {
      var g = this._kitNudgeGate;
      if (this._kitNudgeActive && g && g.allowed && match && match.tier === g.tier) armKitNudgeSrc(g.tier);
    } catch (e) {}
    return origUpsellClickKN.apply(this, arguments);
  };

  /* Stamp `_hgn_src` onto the bundle lines of a kit that came from this
     card. The kit-build snippet owns bundleProps and is not edited (it is
     the 256 KB file's sibling and has its own paste cadence), so the
     property is injected into the finalise POST here. Underscore-prefixed
     → invisible on the line, which is what the offers audit requires of
     anything added after a BASKET-* fold. Passes the request through
     untouched on any parse failure. */
  if (!window.__hgnKitNudgeStamp) {
    window.__hgnKitNudgeStamp = true;
    var origFetchKN = window.fetch;
    window.fetch = function (input, init) {
      try {
        var url = input && (input.url || input);
        if (typeof url === 'string' && /\/cart\/add(\.js)?([?#]|$)/.test(url) &&
            init && typeof init.body === 'string' && init.body.indexOf('_bundle_type') !== -1) {
          var armed = readKitNudgeSrc();
          if (armed) {
            var payload = JSON.parse(init.body);
            var list = payload.items || (payload.id ? [payload] : []);
            var touched = false;
            list.forEach(function (it) {
              var props = it && it.properties;
              if (!props || props._hgn_src) return;
              if (String(props._bundle_type || '') !== armed.tier + '-starter-kit') return;
              props._hgn_src = 'kitnudge:' + armed.tier + ':sidecart';
              touched = true;
            });
            if (touched) {
              var copy = {};
              for (var k in init) if (Object.prototype.hasOwnProperty.call(init, k)) copy[k] = init[k];
              copy.body = JSON.stringify(payload);
              init = copy;
              /* 2026-09-19: consume the source only when the add succeeds (see the
                 curated shim for why); the accept beacon moves with it. */
              var stampedKN = { kind: armed.tier };
              return origFetchKN.call(this, input, init).then(function (res) {
                if (res && res.ok) {
                  clearKitNudgeSrc();
                  offerEvent('kitnudge_accepted', stampedKN);
                }
                return res;
              });
            }
          }
        }
      } catch (e) {}
      return origFetchKN.call(this, input, init);
    };
  }

  /* Manual-test aid: window.HGN.kitNudgeDebug() → the live verdict.
     `kitCommitSelf` is the drawer instance the _render wrapper above
     captures; the main file never exposes one (window.HGN.sideCart is a
     closure facade), so this is the only handle there is. */
  try {
    window.HGN = window.HGN || {};
    window.HGN.kitNudgeDebug = function () {
      var inst = kitCommitSelf;
      var cart = inst && inst.cart;
      return {
        arm: (window.HGN.arms || {}).kitnudge || null,
        active: !!(inst && inst._kitNudgeActive),
        last: (inst && inst._kitNudgeGate) || null,
        gate: cart ? kitNudgeGate(cart, { cfg: kitNudgeCfg(inst) }) : null,
        cfg: kitNudgeCfg(inst),
        armedSrc: readKitNudgeSrc()
      };
    };
  } catch (e) {}

})();
